import AppAssets from "@toothfairy/shared-ui/AppAssets";
import AppExpander from "@toothfairy/shared-ui/AppExpander";
import AppForms from "@toothfairy/shared-ui/AppForms";
import AppTheme from "@toothfairy/shared-ui/AppTheme";
import AppInputLabel from "@toothfairy/shared-ui/AppInputLabel";
import AppStateManager from "@toothfairy/shared-ui/AppStateManager";
import AppPlaceholderView from "@toothfairy/shared-ui/AppPlaceholderView";
import AppTable from "@toothfairy/shared-ui/AppTable";
import { AppText, AppIcon } from "@toothfairy/shared-ui";
import React, { useCallback, useEffect, useState } from "react";
import { View } from "react-native";
import AppToast from "@toothfairy/shared-ui/AppToast";
import ToothFairyButton from "../../../../../Components/ToothFairyComponents/ToothFairyButton";
import Constants from "../../../../../Constants";
import useWorkspaces from "../../../../../Hooks/useWorkspaces";
import Color from "../../../../../Utility/Color";
import { isLargeScreen } from "../../../../MainViewContainer";
import AdminInfoLeaf from "../../../../Admin/Components/SubComponents/AdminInfoLeaf";
import ImagePlaceholder from "../../../../../Components/ImagePlaceholder";
import trainingAPI from "../../../../../API/Training/trainingAPI";
import Files from "../../../../../API/Files";
import envConfig from "../../../../../../envConfig";
import useAPI from "@toothfairy/shared-api/useApi";
import axios from "axios";
import AppUtilities from "@toothfairy/shared-ui/AppUtilities";
import Utility, { generateRowId } from "../../../../../Utility";
import hostingsHelper from "../../../../../API/Hostings/hostingsHelper";
import colorsMappings from "../../../../Common/colorsMappings";
import AudioPlaceholder from "../../../../../Components/AudioPlaceholder";
import AudioRecorder from "../../../../../Components/AudioRecorder";
import messagesHelper from "../../../../../API/Messages/messagesHelper";
import { useHistory } from "../../../../../Router";
import useOllamaModels from "../../../../../Hooks/useOllamaModels";
import authorisationsHelper from "../../../../../API/Authorisations/authorisationsHelper";
import dayjs from "dayjs";
import { default as AppConfig } from "../../../../../Constants";
import { isOllamaRunning } from "../../../../../../App";

const columns = [
  {
    title: "Benchmark",
    width: 0.4,
  },
  {
    title: "Score",
    width: 0.3,
  },
  {
    title: "Datetime",
    width: 0.3,
  },
];

const _tools = [
  {
    id: "deep_thinking",
    name: "Deep Thinking",
    description: "Allow the model to think before responding",
    icon: "reasoning",
  },
  {
    id: "rag",
    name: "RAG (Retrieval-Augmented Generation)",
    description: "Generate text based on retrieved information.",
    icon: "rag",
  },
  {
    id: "internet_search",
    name: "Internet Search",
    description: "Search the internet for information.",
    icon: "search",
  },
  {
    id: "code_interpreter",
    name: "Code Interpreter",
    description: "Interpret and execute code.",
    icon: "code",
  },
  {
    id: "greeting",
    name: "Greeting",
    description: "Greet the user.",
    icon: "greeting",
  },
  {
    id: "image_creation",
    name: "Image Creation",
    description: "Create images from text descriptions.",
    icon: "image",
  },

  {
    id: "video_generation",
    name: "Video Generation",
    description: "Generate videos from text descriptions.",
    icon: "video",
  },
  {
    id: "3d_model_generation",
    name: "3D Model Generation",
    description: "Generate 3D models from text descriptions.",
    icon: "3d",
  },
  {
    id: "long_term_memory",
    name: "Long Term Memory",
    description: "Store and retrieve information over long periods.",
    icon: "memory",
  },
  {
    id: "images_retrieval",
    name: "Images Retrieval",
    description: "Retrieve images from the internet.",
    icon: "image",
  },

  {
    id: "conversation_retrieval",
    name: "Conversation Retrieval",
    description: "Retrieve information from previous conversations.",
    icon: "message",
  },
];

const controller = new AbortController();
const internetSearchLocations = [
  {
    name: "Australia",
  },
  {
    name: "Canada",
  },
  {
    name: "New Zealand",
  },
  {
    name: "United States",
  },
  {
    name: "United Kingdom",
  },
  {
    name: "Japan",
  },
  {
    name: "Mexico",
  },
  {
    name: "Mumbai, Maharashtra, India",
  },
  {
    name: "Bangkok, Bangkok, Thailand",
  },
  {
    name: "Paris, Paris, Ile-de-France, France",
  },
];

const _proModels = [];

export const _baseModels = [
  {
    name: "TF Sorcerer",
    id: "sorcerer",
    tfOnly: true,
    dynamicRouting: true,
  },
  {
    name: "TF Sorcerer 1.5 Thinking",
    id: "sorcerer_15",
    tfOnly: true,
    dynamicRouting: true,
    reasoner: true,
    maxTokens: 32000,
  },
  // {
  //   name: "TF Sorcerer 1.5 optimised exp.",
  //   id: "sorcerer_15_turbo",
  //   tfOnly: true,
  //   experimental: true,
  // },
  {
    name: "TF Mystica",
    id: "mystica",
    tfOnly: true,
    dynamicRouting: true,
  },
  {
    name: "TF Mystica 1.5 Thinking",
    id: "mystica_15",
    tfOnly: true,
    dynamicRouting: true,
    reasoner: true,
    maxTokens: 32000,
  },
  {
    name: "Dynamic model routing",
    id: "dynamic",
    tfOnly: true,
  },
  {
    name: "Llama 4 Maverick",
    id: "meta-llama/Llama-4-Maverick",
    dynamicRouting: true,
    maxTokens: 32000,
  },
  {
    name: "Llama 4 Scout",
    id: "meta-llama/Llama-4-Scout",
    dynamicRouting: true,
    maxTokens: 32000,
  },
  {
    name: "Llama 3.3 70b",
    id: "meta-llama/Llama-3.3-70B-Instruct-Turbo",
    dynamicRouting: true,
    maxTokens: 32000,
  },
  {
    name: "Qwen 3 235b",
    id: "Qwen/Qwen3-235B-Instruct",
    reasoner: true,
    dynamicRouting: true,
    maxTokens: 32000,
  },
  {
    name: "Qwen 3 30b",
    id: "Qwen/Qwen3-30B-Instruct",
    reasoner: true,
    dynamicRouting: true,
    maxTokens: 32000,
  },
  {
    name: "Qwen 2.5 Coder 32b",
    id: "Qwen/Qwen2.5-Coder-32B-Instruct",
    dynamicRouting: true,
  },
  {
    name: "Qwen 2.5 72b",
    id: "Qwen/Qwen2.5-72B-Instruct-Turbo",
    dynamicRouting: true,
  },
  {
    name: "Qwen 2.5 7b",
    id: "Qwen/Qwen2.5-7B-Instruct-Turbo",
  },
  {
    name: "DeepSeek R1-0528",
    id: "deepseek-ai/DeepSeek-R1",
    reasoner: true,
    dynamicRouting: true,
  },
  {
    name: "DeepSeek R1 - Llama 3.3 70b Distill",
    id: "deepseek-ai/DeepSeek-R1-Distill-Llama-70B",
    reasoner: true,
    dynamicRouting: true,
  },
  {
    name: "DeepSeek R1 - Qwen 14b Distill",
    id: "deepseek-ai/DeepSeek-R1-Distill-Qwen-14B",
    reasoner: true,
  },
  {
    name: "DeepSeek R1 - Qwen 1.5b Distill",
    id: "deepseek-ai/DeepSeek-R1-Distill-Qwen-1.5B",
    reasoner: true,
  },
  {
    name: "DeepSeek V3-0324",
    id: "deepseek-ai/DeepSeek-V3",
    dynamicRouting: true,
    maxTokens: 32000,
  },
  // {
  //   name: "DeepSeek V3 - 0324",
  //   id: "deepseek-ai/DeepSeek-V3-0324",
  //   dynamicRouting: true,
  // },
  {
    name: "Llama 3.2 90b",
    id: "meta-llama/Llama-3.2-90B-Vision-Instruct-Turbo",
  },

  {
    name: "Llama 3.1 70b",
    id: "meta-llama/Meta-Llama-3.1-70B-Instruct-Turbo",
  },
  {
    name: "Llama 3.2 11b",
    id: "meta-llama/Llama-3.2-11B-Vision-Instruct-Turbo",
  },
  {
    name: "Llama 3.1 8b",
    id: "meta-llama/Meta-Llama-3.1-8B-Instruct-Turbo",
    dynamicRouting: true,
  },
  {
    name: "Llama 3.2 3b",
    id: "meta-llama/Llama-3.2-3B-Instruct-Turbo",
  },
  {
    name: "Llama 3.1 Nemotron 70b",
    id: "nvidia/Llama-3.1-Nemotron-70B-Instruct-HF",
    dynamicRouting: true,
  },
  {
    name: "Mistral Small 3",
    id: "mistralai/Mistral-Small-24B-Instruct-2501",
  },
  {
    name: "Qwen 2 72b (Deprecated)",
    id: "Qwen/Qwen2-72B-Instruct",
  },
  {
    name: "Mistral 7b v0.1 (Deprecated)",
    id: "mistralai/Mistral-7B-Instruct-v0.1",
  },
  {
    name: "Mistral 7b v0.2 (Deprecated)",
    id: "mistral.mistral-7b-instruct-v0:2",
  },
  {
    name: "Mistral 7b v0.3 (Deprecated)",
    id: "mistralai/Mistral-7B-Instruct-v0.3",
  },
  {
    name: "Mixtral 8x7b (Deprecated)",
    id: "mistral.mixtral-8x7b-instruct-v0:1",
  },
  {
    name: "Mixtral 8x22b (Deprecated)",
    id: "mistralai/Mixtral-8x22B-Instruct-v0.1",
  },
  {
    name: "Gemma 2 9b (Deprecated)",
    id: "google/gemma-2-9b-it",
  },
  {
    name: "Gemma 2 27b (Deprecated)",
    id: "google/gemma-2-27b-it",
  },
  {
    name: "Llama 3.1 405b (Deprecated)",
    id: "meta-llama/Meta-Llama-3.1-405B-Instruct-Turbo",
  },
  {
    name: "QwQ-32b (Deprecated)",
    id: "Qwen/QwQ-32B",
    reasoner: true,
    dynamicRouting: true,
  },
  // {
  //   name: "Mistral Large",
  //   id: "mistral.mistral-large-2402-v1:0",
  // },
];

const visionModels = [
  {
    name: "Sorcerer vision",
    id: "sorcerer",
    tfOnly: true,
  },
  {
    name: "Sorcerer 1.5 vision",
    id: "sorcerer_15",
    tfOnly: true,
  },
  {
    name: "Sorcerer 1.5 optimised vision",
    id: "sorcerer_15_turbo_vision",
    tfOnly: true,
  },
  {
    name: "Mystica vision",
    id: "mystica",
    tfOnly: true,
  },
  {
    name: "Llama 4 Maverick vision",
    id: "meta-llama/Llama-4-Maverick",
  },
  {
    name: "Llama 4 Scout vision",
    id: "meta-llama/Llama-4-Scout",
  },
  {
    name: "Llama 3.2 11b vision",
    id: "meta-llama/Llama-3.2-11B-Vision-Instruct-Turbo",
  },
  {
    name: "Llama 3.2 90b vision",
    id: "meta-llama/Llama-3.2-90B-Vision-Instruct-Turbo",
  },
  {
    name: "Qwen 2 72b vision",
    id: "Qwen/Qwen2-VL-72B-Instruct",
  },
];

const convertContextWithFunctionCallingLabel = (mode) => {
  if (mode == "retriever") return "Functions";
  else if (mode == "planner") return "Planning";
  else if (mode == "computer") return "User interface";
  else {
    return "Tools";
  }
};

const QaSettingsAIView = ({
  isEdit,
  settingType,
  handleDeletion,
  availableFunctions,
  agentsChannels,
  isChatBot,
  isBusinessAnalyst,
  initialMapValues,
  isContentCreator,
  customCodeExecutionEnvironments,
  clearMemory,
}) => {
  const history = useHistory();
  const { currentTheme, mode } = AppTheme.useTheme();
  const entityName = "Prompting";
  const AppToasty = AppToast.useToast();
  const [agentImage, setAgentImage] = React.useState(null);
  const [agentLogo, setAgentLogo] = React.useState(null);
  const [codeExpanded, setCodeExpanded] = React.useState(false);
  const [isAudioRecording, setIsAudioRecording] = useState(false);
  const [finetunedModels, setFinetunedModels] = useState([]);
  const [benchmarks, setBenchmarks] = useState([]);
  const [oLlamaModels, setOllamaModels] = useState([]);
  const [isAgentOllama, setIsAgentOllama] = useState(false);
  const { state } = AppStateManager.useAppStateManager();
  const {
    getTrainingLogsWithModels,
    getWorkspaceEntities,
    getPlanConfig,
    getActiveWorkspace,
    getWorkspaceUsers,
    loadAgents,
    getFinetunedModels,
    getBenchmarksByAgent,
  } = useWorkspaces();
  const {
    error,
    loadedModel,
    downloadingModel,
    modelsAvailable,
    isLoading,
    loadModel,
    pullProgress,
    pullStatus,
  } = useOllamaModels();
  const [_agents, _setAgents] = useState([]);
  const [_authorisations, _setAuthorisations] = useState([]);
  const workspaceid = getActiveWorkspace()?.id;
  const [fileUploadInProgress, setFileUploadInProgress] = React.useState(false);
  const [fileUploadProgress, setFileUploadProgress] = React.useState(0);
  const [disableMultiModal, setDisableMultiModal] = React.useState(false);
  const [disableDueToTranslation, setDisableDueToTranslation] =
    React.useState(false);
  const [agentFeedbackList, setAgentFeedbackList] = React.useState([]);
  const [codeUploadDisabled, setCodeUploadDisabled] = useState(false);
  const [errorsOnModerationRules, setErrorsOnModerationRules] = React.useState(
    []
  );
  const [audioFileUploadProgress, setAudioFileUploadProgress] = useState(null);
  const [initialLoadCompleted, setInitialLoadCompleted] = React.useState(false);
  const [customHostings, setCustomHostings] = React.useState([]);
  const [filteredDocs, setFilteredDocs] = React.useState([]);
  const [baseLlmModels, setBaseLlmModels] = React.useState([]);
  const [functionCallingModels, setFunctionCallingModels] = React.useState([]);
  const [baseLlmProviders, setBaseLlmProviders] = React.useState([]);
  const [baseImageModels, setBaseImageModels] = React.useState([]);
  const [agentVoice, setAgentVoice] = React.useState(null);
  const [functionCallingProviders, setFunctionCallingProviders] =
    React.useState([]);
  const [adverserialProviders, setAdverserialProviders] = React.useState([]);
  const [adverserialModels, setAdverserialModels] = React.useState([]);
  const generateModes = () => {
    const _baseModes = [];
    _baseModes.push({
      name: "Operator",
      id: "retriever",
      description:
        "Well suited for RAG workflows, extensive function calling, API integration and internet searching",
    });
    _baseModes.push({
      name: "Programmer",
      id: "coder",
      description:
        "Programming tasks support, code completion and code execution for workflows and processes automation",
    });
    _baseModes.push({
      name: "Assistant",
      id: "chatter",
      description:
        "The most versatible agent mode well-rounded for everyday tasks such as file analysis, image generation and content creation",
    });
    if (getActiveWorkspace()?.subscriptionType != "base") {
      _baseModes.push({
        name: "Orchestrator",
        id: "planner",
        description:
          "Our most capable agent mode designed to define and execute an execution plan leveraging multiple agents to accomplish complex tasks",
      });
    }
    if (
      getActiveWorkspace()?.subscriptionType == "enterprise" &&
      getActiveWorkspace()?.enableExperimentalFeatures
    ) {
      _baseModes.push({
        name: "Desktop",
        id: "computer",
        description:
          "Our latest agent mode designed to interact with the user interface of a computer (preview)",
      });
    }

    return _baseModes;
  };
  const { setFieldValue, values } = AppForms.useFormikContext();
  const canAgentRunLocally =
    values?.mode == "chatter" || values?.mode == "coder";
  const handleRecordingCompleted = async (blob) => {
    console.log("Recording completed", blob);
    setIsAudioRecording(false);
    const _file = new File([blob], "audio.wav", {
      type: "audio/wav",
    });
    const audioId = generateRowId();
    const result = await S3uploadUrlRequest({
      filename: `${getActiveWorkspace()?.id}/${audioId}.wav`,
      importType: "imported_audio_files",
      contentType: "wav",
    });
    const upload = await axios.request({
      method: "put",
      url: JSON.parse(result?.body)?.uploadURL,
      data: _file,
      headers: {
        "Content-Type": _file.type,
      },
      signal: controller.signal,
      onUploadProgress: (p) => {
        // if (controller.signal.aborted) return;
        setAudioFileUploadProgress(Math.round((p.loaded * 100) / p.total));
        if (p.loaded === p.total) {
          setAudioFileUploadProgress(100);
        }
      },
    });
    console.log("Upload result", upload);
    if (JSON.parse(result?.body).uploadURL) {
      setFieldValue(
        "voiceFileKey",
        `imported_audio_files/${getActiveWorkspace()?.id}/${audioId}.wav`
      );
    }
  };
  const handleRecordingStarted = () => {
    setIsAudioRecording(true);
    console.log("Recording started");
  };
  const isTfModel =
    ["sorcerer", "mystica", "sorcerer_15", "mystica_15"].find(
      (u) => u == values?.llmBaseModel
    ) != null || values?.llmBaseModel == null;
  const isKnowledgeEnabled =
    !values?.mode ||
    values?.mode == "retriever" ||
    values?.mode == "speed" ||
    values?.mode == "accuracy" ||
    values?.mode == "coder" ||
    !isChatBot;
  const isCharacterNeeded = isChatBot && values?.mode != "mathematician";
  const _modes = generateModes();
  const agentLink = `https://agent.${
    envConfig?.REACT_APP_ENV == "dev"
      ? "toothfairylab.link"
      : "toothfairyai.com"
  }/${workspaceid}/${initialMapValues?.id}${
    ["light", "dark"]?.includes(values?.forcedTheme)
      ? "/tf_" + values?.forcedTheme
      : ""
  }`;
  const widgetString = isEdit
    ? `<div id="tfChatWidget" style="position: fixed; bottom: 10px; right: 10px; z-index: 10;">
  <style>
    #tfChatWidget { border: none; background-color: transparent; }
    #tfChatWidget.open { border: 0.5px solid grey; background-color: white; }
    .tfChatBtn { border: none; border-radius: 5px; padding: 10px 15px; margin: 5px; cursor: pointer; transition: background 0.3s; }
    #tfWidget { display: none; width: 360px; height: 400px; border: none; }
  </style>
  <iframe id="tfWidget" src="${agentLink}"></iframe>
  <div style="display: flex; justify-content: space-between">
    <button id="tfOpenChat" onclick="tfToggleChat(true)" class="tfChatBtn">Chat with ${initialMapValues?.label}</button>
    <button id="tfStartNew" onclick="tfStartNewChat()" style="display: none;" class="tfChatBtn">New chat</button>
    <button id="tfCloseChat" onclick="tfToggleChat(false)" style="display: none;" class="tfChatBtn">Close chat</button>
  </div>
</div>

<script>
  function tfToggleChat(open) {
    const widget = document.getElementById('tfChatWidget');
    widget.classList.toggle('open', open);
    document.getElementById('tfWidget').style.display = open ? 'block' : 'none';
    ['tfOpenChat', 'tfStartNew', 'tfCloseChat'].forEach(id => 
      document.getElementById(id).style.display = open ? (id === 'tfOpenChat' ? 'none' : 'block') : (id === 'tfOpenChat' ? 'block' : 'none')
    );
  }

  function tfStartNewChat() {
    document.getElementById('tfWidget').src += '';
    tfToggleChat(true);
  }
</script>`
    : `Code will be generated after saving`;
  const {
    data: S3uploadUrlData,
    loading: urlUploadGenerationInProgress,
    apiRequest: S3uploadUrlRequest,
    response: S3uploadResponse,
  } = useAPI(trainingAPI.bulkImportUrlGeneration, envConfig);
  const {
    data: S3downloadUrlData,
    loading: urldownloadGenerationInProgress,
    apiRequest: S3downloadUrlRequest,
    response: S3downloadResponse,
  } = useAPI(Files.downloadUrlGeneration, envConfig);

  const _title = useCallback(() => {
    return isEdit ? `Save` : `Create`;
  }, [entityName, isEdit]);
  const getUrl = async (path, isLargeLogo) => {
    const _url = await S3downloadUrlRequest({
      filename: `imported-image/${workspaceid}/${path}`,
      context: "pdf",
      workspaceid,
    });
    if (isLargeLogo && _url?.url) setAgentLogo(_url?.url);
    else if (_url?.url) setAgentImage(_url?.url);
    else if (isLargeLogo) setAgentLogo(null);
    else setAgentImage(null);
  };
  const getCustomHostings = async () => {
    try {
      const result = await hostingsHelper.getHostings(workspaceid);
      const _hostings =
        result?.data?.HostingsByWorkspace?.items?.filter(
          (u) => u?._deleted != true
        ) || [];
      setCustomHostings(_hostings);
    } catch (error) {
      console.log(
        "Error getting hostings - attempting to switch to Ollama is present",
        error
      );
    }
  };

  const getFeedbackForAgent = async () => {
    try {
      const _feedback = await messagesHelper.getChatMessagesByAgent(
        initialMapValues?.id
      );
      setAgentFeedbackList(_feedback?.data?.messagesByAgent?.items);
    } catch (error) {
      console.log("Error getting feedback", error);
      setAgentFeedbackList([]);
    }
  };
  useEffect(() => {
    setTimeout(() => {
      setInitialLoadCompleted(true);
    }, [2000]);
  }, []);
  useEffect(() => {
    if (values?.llmBaseModel) {
      const _maxTokens = _baseModels?.find(
        (u) => u?.id == values?.llmBaseModel
      )?.maxTokens;
      if (!_maxTokens) {
        setFieldValue("maxTokens", getMaxTokensBasedOnModels(values));
      } else if (values?.maxTokens > _maxTokens)
        setFieldValue("maxTokens", getMaxTokensBasedOnModels(values));
    }
  }, [values?.llmBaseModel, values?.maxTokens]);
  useEffect(() => {
    const pullAvailableModelsInOllama = async () => {
      const hostingsData = await hostingsHelper.getHostings(
        getActiveWorkspace()?.id,
        null
      );
      const hostings = hostingsData?.data?.HostingsByWorkspace?.items;
      const _localHosting = hostings?.find(
        (u) => u?.name == values?.llmProvider
      );
      if (_localHosting?.type == "ollama") {
        setIsAgentOllama(true);
        const model_response = await axios.get(
          `${_localHosting?.endpoint}/api/tags`,
          {
            headers: {
              "Content-Type": "application/json",
            },
          }
        );
        if (model_response?.status == 200) {
          isOllamaRunning(true);
          setOllamaModels([
            {
              name: "No model selected",
              id: "none",
            },
            ...model_response?.data?.models?.map((u) => {
              return {
                name: u?.name,
                id: u?.model,
              };
            }),
          ]);
        }
      } else {
        setIsAgentOllama(false);
      }
    };

    if (canAgentRunLocally) pullAvailableModelsInOllama();
    else {
      setOllamaModels([]);
      setIsAgentOllama(false);
    }
  }, [canAgentRunLocally, values?.llmProvider]);

  // useEffect(() => {
  //   if (values?.llmProvider && initialLoadCompleted) {
  //     if (
  //       baseLlmModels?.length > 0 &&
  //       !baseLlmModels?.find((u) => u?.id == values?.llmBaseModel)
  //     ) {
  //       setFieldValue("llmBaseModel", baseLlmModels[0]?.id);
  //     }
  //   }
  // }, [
  //   values?.llmProvider,
  //   initialLoadCompleted,
  //   JSON.stringify(baseLlmModels),
  // ]);
  useEffect(() => {
    if (workspaceid) getCustomHostings();
  }, [workspaceid, canAgentRunLocally]);
  useEffect(() => {
    if (initialMapValues?.id) getFeedbackForAgent();
  }, [initialMapValues?.id]);
  useEffect(() => {
    if (
      values?.baseImageGenerationModel == "black-forest-labs/flux-pro" ||
      values?.baseImageGenerationModel == "black-forest-labs/flux-1.1-pro" ||
      values?.baseImageGenerationModel == "black-forest-labs/flux-1.1-pro-ultra"
    )
      setFieldValue("maxImagesGenerated", 1);
  }, [values?.baseImageGenerationModel]);
  useEffect(() => {
    if (getActiveWorkspace()?.subscriptionType) {
      setBaseLlmProviders(
        matchProvidersWithSubscription(
          getActiveWorkspace()?.subscriptionType,
          false,
          customHostings
        )
      );
      let base_models = [
        {
          name: "Mystica SD",
          id: "mystica_sd",
        },
        {
          name: "Mystica realism SD",
          id: "mystica_realism_sd",
        },
      ];
      if (getActiveWorkspace()?.subscriptionType == "enterprise") {
        base_models = [
          ...base_models,
          {
            name: "Flux Pro",
            id: "black-forest-labs/flux-pro",
          },
          {
            name: "Flux Pro 1.1",
            id: "black-forest-labs/flux-1.1-pro",
          },
          {
            name: "Flux Pro 1.1 Ultra Realistic",
            id: "black-forest-labs/flux-1.1-pro-ultra",
          },
        ];
      }
      setBaseImageModels(base_models);
      setFunctionCallingProviders(
        matchProvidersWithSubscription(
          getActiveWorkspace()?.subscriptionType,
          true,
          customHostings
        )
      );
      setAdverserialProviders(
        matchProvidersWithSubscription(
          getActiveWorkspace()?.subscriptionType,
          true,
          customHostings
        )
      );
      setBaseLlmModels(
        matchModelsWithProviders(
          values?.llmProvider,
          getActiveWorkspace()?.subscriptionType,
          false,
          customHostings
        )?.filter(
          (u) =>
            u?.experimental != true ||
            u?.experimental == getActiveWorkspace()?.enableExperimentalFeatures
        )
      );
      setFunctionCallingModels(
        matchModelsWithProviders(
          values?.functionCallingProvider,
          getActiveWorkspace()?.subscriptionType,
          true,
          customHostings
        )?.filter(
          (u) =>
            u?.experimental != true ||
            u?.experimental == getActiveWorkspace()?.enableExperimentalFeatures
        )
      );
      setAdverserialModels(
        matchModelsWithProviders(
          values?.adverserialProvider,
          getActiveWorkspace()?.subscriptionType,
          true,
          customHostings
        )?.filter(
          (u) =>
            u?.experimental != true ||
            u?.experimental == getActiveWorkspace()?.enableExperimentalFeatures
        )
      );
    }
  }, [
    values?.adverserialProvider,
    values?.functionCallingProvider,
    values?.llmProvider,
    JSON.stringify(customHostings),
    JSON.stringify(finetunedModels),
    getActiveWorkspace()?.subscriptionType,
    canAgentRunLocally,
  ]);
  useEffect(() => {
    if (
      values?.functionCallingModel != null &&
      initialLoadCompleted &&
      functionCallingModels.find(
        (u) => u?.id == values?.functionCallingModel
      ) == null
    ) {
      setFieldValue("functionCallingModel", functionCallingModels[0]?.id);
    }
  }, [
    values?.functionCallingProvider,
    values?.functionCallingModel,
    functionCallingModels?.map((u) => u?.id),
  ]);
  useEffect(() => {
    if (values?.icon) {
      getUrl(values?.icon);
    } else {
      setAgentImage(null);
    }
  }, [values?.icon]);
  useEffect(() => {
    if (values?.largeLogo) {
      getUrl(values?.largeLogo, true);
    } else {
      setAgentLogo(null);
    }
  }, [values?.largeLogo]);
  useEffect(() => {
    if (values?.voiceFileKey) {
      getUrl(values?.voiceFileKey, true);
    } else {
      setAgentVoice(null);
    }
  }, [values?.voiceFileKey]);
  useEffect(() => {
    if (
      getActiveWorkspace()?.subscriptionType == "base" &&
      _proModels?.map((u) => u?.id)?.includes(values?.llmBaseModel)
    ) {
      setFieldValue("llmBaseModel", "sorcerer");
    }
    if (
      getActiveWorkspace()?.subscriptionType == "base" &&
      (values?.functionCallingModel ==
        "mistralai/Mixtral-8x22B-Instruct-v0.1" ||
        values?.functionCallingModel == "meta-llama/Llama-3-70b-chat-hf")
    ) {
      setFieldValue("functionCallingModel", "sorcerer");
    }
    if (getActiveWorkspace()?.subscriptionType == "enterprise")
      setFinetunedModels(getFinetunedModels());
  }, [getActiveWorkspace()?.subscriptionType]);
  useEffect(() => {
    if (!isEdit) {
      if (isChatBot) {
        setFieldValue("maxTokens", 2048);
        setFieldValue("temperature", values?.temperature || 0.5);
        setFieldValue("showReferencesToInternalDocs", true);
        setFieldValue(
          "maxHistory",
          values?.mode === "coder" || values?.mode === "chatter" ? 10 : 3
        );
        setFieldValue("topK", 4);
        setFieldValue("docTopK", 3);
        setFieldValue("hasTopicsContext", isKnowledgeEnabled);
        setFieldValue("hasFunctions", isKnowledgeEnabled);
      } else {
        setFieldValue("hasTopicsContext", true);
      }
    }
  }, [isChatBot, isKnowledgeEnabled, values?.mode, isEdit]);
  useEffect(() => {
    if (values?.hasTopicsContext != true) setFieldValue("blender", false);
  }, [values?.hasTopicsContext]);
  useEffect(() => {
    if (
      values?.mode == "coder" &&
      values?.allowDocsUpload == true &&
      values?.hasCode == true
    ) {
      setCodeUploadDisabled(false);
      setFieldValue("allowDocsUpload", !values?.hasCode);
      setTimeout(() => {
        setCodeUploadDisabled(true);
      }, 300);
    } else if (values?.mode == "coder" && values?.hasCode != true)
      setCodeUploadDisabled(false);
  }, [values?.allowDocsUpload, values?.hasCode, values?.mode]);
  useEffect(() => {
    if (values?.isMultiLanguageEnabled) {
      setFieldValue("charting", false);
      setTimeout(() => {
        setDisableDueToTranslation(true);
      }, 500);
    } else {
      setDisableDueToTranslation(false);
    }
  }, [values?.isMultiLanguageEnabled]);
  const handleAudioSelection = async (file) => {
    if (!file) {
      setFieldValue("voiceFileKey", null);
      return;
    }
    // Extract the file name and extension
    // generate a random file name
    const filename = file.name;
    const _fileN = String(Date.now()) + filename;
    const contentType = filename.slice(
      (Math.max(0, filename.lastIndexOf(".")) || Infinity) + 1
    );
    const result = await S3uploadUrlRequest({
      filename: `${workspaceid}/${_fileN}`,
      importType: "imported_audio_voices",
      contentType,
    });
    const upload = await axios.request({
      method: "put",
      url: JSON.parse(result?.body)?.uploadURL,
      data: file,
      headers: {
        "Content-Type": file.type,
      },
      onUploadProgress: (p) => {
        setFileUploadInProgress(true);
        setFileUploadProgress(Math.round((p.loaded * 100) / p.total));
        if (p.loaded === p.total) {
          setFileUploadInProgress(false);
          setFileUploadProgress(100);
        }
      },
    });
    if (JSON.parse(result?.body).uploadURL) {
      setFieldValue(
        "voiceFileKey",
        `imported_audio_files/${workspaceid}/${_fileN}`
      );
    }
  };
  const handleIconSelection = async (file, isLargeLogo) => {
    if (!file && isLargeLogo) {
      setFieldValue("largeLogo", null);
      return;
    } else if (!file) {
      setFieldValue("icon", null);
      return;
    }
    // Extract the file name and extension
    // generate a random file name
    const filename = file.name;
    const _fileN = String(Date.now()) + filename;
    const contentType = filename.slice(
      (Math.max(0, filename.lastIndexOf(".")) || Infinity) + 1
    );
    const result = await S3uploadUrlRequest({
      filename: `${workspaceid}/${_fileN}`,
      importType: "imported-image",
      contentType,
    });
    const upload = await axios.request({
      method: "put",
      url: JSON.parse(result?.body)?.uploadURL,
      data: file,
      headers: {
        "Content-Type": file.type,
      },
      onUploadProgress: (p) => {
        setFileUploadInProgress(true);
        setFileUploadProgress(Math.round((p.loaded * 100) / p.total));
        if (p.loaded === p.total) {
          setFileUploadInProgress(false);
          setFileUploadProgress(100);
        }
      },
    });
    if (JSON.parse(result?.body).uploadURL) {
      setFieldValue(isLargeLogo ? "largeLogo" : "icon", _fileN);
    }
  };
  useEffect(() => {
    if (
      values?.plainTextOutput ||
      (!["sorcerer", "mystica", "sorcerer_15", "mystica_15"]?.find(
        (u) => u == values?.llmBaseModel
      ) &&
        values?.llmBaseModel != null)
    ) {
      setFieldValue("charting", false);
      setFieldValue("hasImages", false);
      // setFieldValue("allowDocsUpload", false);
      setTimeout(() => {
        setDisableMultiModal(true);
      }, 500);
    } else {
      setDisableMultiModal(false);
    }
  }, [
    values?.plainTextOutput,
    values?.llmProvider,
    values?.llmBaseModel,
    values?.isMultiLanguageEnabled,
  ]);
  useEffect(() => {
    if (!values?.allowAudiosGeneration) {
      setFieldValue("autoVoiceMode", false);
    }
  }, [values?.allowAudiosGeneration]);
  useEffect(() => {
    if (values?.restrictedAccess) {
      setFieldValue("preventWidgetUsage", true);
    }
  }, [values?.restrictedAccess]);
  const getMaxTokensBasedOnModels = (values) => {
    return (
      _baseModels?.find((u) => u?.id == values?.llmBaseModel)?.maxTokens || 8192
    );
  };
  function getMaxTokens(
    isContentCreator,
    isChatBot,
    getActiveWorkspace,
    values
  ) {
    if (isContentCreator) {
      return getActiveWorkspace()?.isExtendedContentCreatorEnabled
        ? getMaxTokensBasedOnModels(values)
        : getMaxTokensBasedOnModels(values);
    } else if (isChatBot) {
      if (
        values?.mode === "coder" ||
        values?.mode === "chatter" ||
        values?.mode === "retriever"
      )
        return getMaxTokensBasedOnModels(values);
      else {
        return getMaxTokensBasedOnModels(values);
      }
    } else {
      return getMaxTokensBasedOnModels(values);
    }
  }

  const _topics = getWorkspaceEntities("topic")?.map((topic) => {
    topic.name = topic["label"];
    topic.category = topic["type"];
    return { ...topic };
  });

  useEffect(() => {
    if (values?.allowedTopics && values?.allowedTopics?.length > 0) {
      let filteredObjects = state?.embeddedMrcDocuments
        ?.filter((obj) => {
          return obj?.topics?.some((id) =>
            values?.allowedTopics?.map((v) => v?.id)?.includes(id)
          );
        })
        ?.map((u) => {
          return {
            ...u,
            backgroundColor: currentTheme?.theme?.primary,
            name: u?.title,
            category: "docs",
            label: u?.title,
            value: u?.id,
          };
        });
      setFilteredDocs(filteredObjects);
    } else {
      setFieldValue("staticDocs", null);
    }
  }, [values?.allowedTopics]);

  const _functionContext = [
    {
      id: "customer",
      label: "Customer",
      type: "ner",
      backgroundColor: currentTheme?.theme?.primary,
    },
    {
      id: "case",
      label: "Case",
      type: "ner",
      backgroundColor: currentTheme?.theme?.green,
    },
    {
      id: "chat",
      label: "Chat",
      type: "ner",
      backgroundColor: currentTheme?.theme?.orange,
    },
  ]?.map((topic) => {
    topic.name = topic["label"];
    topic.category = topic["type"];
    return { ...topic };
  });
  // REMOVE FILTER WHEN AGENT DESKTOP CAN BE USED BY PLANNER
  const fetchAgents = async () => {
    const __agents = await loadAgents(getActiveWorkspace()?.id);
    if (__agents?.length > 0) {
      _setAgents(
        __agents
          ?.filter((u) => u?.agentType == "Chatbot" && u?.mode != "planner")
          ?.map((agent) => {
            return {
              id: agent["id"],
              label: agent["label"],
              name: agent["label"],
              value: agent["id"],
              category: agent["agentType"],
              backgroundColor:
                colorsMappings.mapBackgroundColorWithAgentTypeAndMode(
                  agent,
                  currentTheme
                ),
            };
          })
      );
    }
  };
  const fetchAuthorisations = async () => {
    const __authorisations = await authorisationsHelper.getAuthorisations(
      getActiveWorkspace()?.id
    );
    if (__authorisations?.data?.authorisationsByWorkspace?.items?.length > 0) {
      _setAuthorisations(
        __authorisations?.data?.authorisationsByWorkspace?.items
          ?.filter((u) => u?.type == "username_and_password")
          ?.map((auth) => {
            return {
              id: auth["id"],
              label: auth["name"],
              name: auth["name"],
              value: auth["id"],
              category: auth["type"],
              backgroundColor:
                colorsMappings.mapBackgroundColorWithAgentTypeAndMode(
                  auth,
                  currentTheme
                ),
            };
          })
      );
    }
  };
  useEffect(() => {
    fetchAgents();
    fetchAuthorisations();
  }, [getActiveWorkspace()?.id]);

  useEffect(() => {
    if (!values?.isMultiLanguageEnabled)
      setFieldValue("advancedLanguageDetection", false);
  }, [values?.isMultiLanguageEnabled]);

  const appendCustomProviders = (baseModels, customHostings, type) => {
    const togetherHostings = customHostings?.filter((u) => u?.type == type);
    for (const hosting of togetherHostings) {
      baseModels.push({
        name: hosting?.name,
        id: hosting?.name,
      });
    }
    return baseModels;
  };

  const matchProvidersWithSubscription = (
    subscriptionPlan,
    functionCalling = false,
    customHostings = []
  ) => {
    if (functionCalling) {
      let baseModels = [{ name: "ToothFairyAI", id: "tf" }];
      if (customHostings?.find((u) => u?.type == "together"))
        appendCustomProviders(baseModels, customHostings, "together");

      if (customHostings?.find((u) => u?.type == "azure_openai"))
        appendCustomProviders(baseModels, customHostings, "azure_openai");
      if (customHostings?.find((u) => u?.type == "aws"))
        appendCustomProviders(baseModels, customHostings, "aws");
      if (customHostings?.find((u) => u?.type == "groq"))
        appendCustomProviders(baseModels, customHostings, "groq");
      return baseModels;
    }
    let hostingModels = [{ name: "ToothFairyAI", id: "tf" }] || [];
    if (customHostings?.find((u) => u?.type == "together"))
      appendCustomProviders(hostingModels, customHostings, "together");
    if (customHostings?.find((u) => u?.type == "replicate"))
      appendCustomProviders(hostingModels, customHostings, "replicate");
    if (customHostings?.find((u) => u?.type == "groq"))
      appendCustomProviders(hostingModels, customHostings, "groq");
    if (customHostings?.find((u) => u?.type == "ollama") && canAgentRunLocally)
      appendCustomProviders(hostingModels, customHostings, "ollama");
    if (
      subscriptionPlan === "enterprise" ||
      getActiveWorkspace()?.enableExperimentalFeatures
    ) {
      if (customHostings?.find((u) => u?.type == "aws"))
        appendCustomProviders(hostingModels, customHostings, "aws");
      if (customHostings?.find((u) => u?.type == "openai"))
        appendCustomProviders(hostingModels, customHostings, "openai");
      if (customHostings?.find((u) => u?.type == "azure_openai"))
        appendCustomProviders(hostingModels, customHostings, "azure_openai");
      if (customHostings?.find((u) => u?.type == "anthropic"))
        appendCustomProviders(hostingModels, customHostings, "anthropic");
      if (customHostings?.find((u) => u?.type == "google"))
        appendCustomProviders(hostingModels, customHostings, "google");
      if (customHostings?.find((u) => u?.type == "local"))
        appendCustomProviders(hostingModels, customHostings, "local");
    }
    return hostingModels;
  };

  useEffect(() => {
    if (
      customHostings?.find(
        (u) => values?.llmProvider == u?.name && u?.type == "ollama"
      ) &&
      values?.llmBaseModel != null
    ) {
      // loadModel(values?.llmBaseModel);
    }
  }, [values?.llmProvider, values?.llmBaseModel, customHostings]);
  useEffect(() => {
    if (
      values?.maxTokens &&
      values?.reasoningBudget &&
      values?.reasoningBudget >= values?.maxTokens
    ) {
      setFieldValue("reasoningBudget", values?.maxTokens - 50);
    }
  }, [values?.maxTokens, values?.reasoningBudget]);
  useEffect(() => {
    if (
      state?.benchmarks?.length > 0 &&
      state?.batchLogs?.length &&
      initialMapValues?.id
    ) {
      setBenchmarks(getBenchmarksByAgent(initialMapValues?.id));
    } else {
      setBenchmarks([]);
    }
  }, [
    state?.benchmarks?.length,
    state?.batchLogs?.length,
    initialMapValues?.id,
  ]);
  const matchModelsWithProviders = (
    llmProvider,
    subscriptionPlan,
    functionCalling = false,
    customHostings = []
  ) => {
    const llmProviderType = customHostings?.find(
      (u) => u?.name == llmProvider
    )?.type;
    const customModels =
      customHostings
        ?.filter((u) => u?.name == llmProvider)
        ?.map((u) => {
          if (u?.modelName)
            return {
              name: u?.modelName,
              id: u?.modelName,
            };
        })
        ?.filter((u) => u) || [];
    if (functionCalling) {
      switch (llmProviderType) {
        case "tf":
          return [
            {
              name: "TF Sorcerer",
              id: "sorcerer",
              plannerAvailable: true,
            },
            {
              name: "TF Sorcerer 1.5 Thinking",
              id: "sorcerer_15",
              plannerAvailable: true,
            },
            {
              name: "TF Mystica",
              id: "mystica",
              plannerAvailable: true,
            },
            {
              name: "TF Mystica 1.5 Thinking",
              id: "mystica_15",
              plannerAvailable: true,
            },
            {
              name: "Qwen 3 235b",
              id: "Qwen/Qwen3-235B-Instruct",
              plannerAvailable: true,
            },
            {
              name: "Qwen 2.5 72b",
              id: "Qwen/Qwen2.5-72B-Instruct-Turbo",
              plannerAvailable: true,
            },
            {
              name: "DeepSeek V3-0324",
              id: "deepseek-ai/DeepSeek-V3",
              plannerAvailable: true,
            },
            {
              name: "Mistral Small 3",
              id: "mistralai/Mistral-Small-24B-Instruct-2501",
              plannerAvailable: true,
            },
            {
              name: "Llama 4 Maverick",
              id: "meta-llama/Llama-4-Maverick",
              plannerAvailable: true,
            },
            {
              name: "Llama 4 Scout",
              id: "meta-llama/Llama-4-Scout",
              plannerAvailable: true,
            },
            {
              name: "Llama 3.3 70b",
              id: "meta-llama/Llama-3.3-70B-Instruct-Turbo",
              plannerAvailable: true,
            },
            {
              name: "Llama 3.1 405b",
              id: "meta-llama/Meta-Llama-3.1-405B-Instruct-Turbo",
              plannerAvailable: false,
            },
            {
              name: "Qwen 2.5 72b",
              id: "Qwen/Qwen2.5-72B-Instruct-Turbo",
              plannerAvailable: false,
            },
            {
              name: "Llama 3.1 70B",
              id: "meta-llama/Meta-Llama-3.1-70B-Instruct-Turbo",
              plannerAvailable: false,
            },
            {
              name: "Llama 3.1 Nemotron 70B",
              id: "nvidia/Llama-3.1-Nemotron-70B-Instruct-HF",
              plannerAvailable: true,
            },
            {
              name: "Llama 3.1 8b",
              id: "meta-llama/Meta-Llama-3.1-8B-Instruct-Turbo",
              plannerAvailable: false,
            },
            ...finetunedModels,
          ];
        case "together":
          return [
            {
              name: "Mistral 7b",
              id: "mistralai/Mistral-7B-Instruct-v0.1",
            },
            {
              name: "Mixtral 8x7b",
              id: "mistralai/Mixtral-8x7B-Instruct-v0.1",
            },
            ...customModels,
          ];
        case "aws":
          return [
            {
              name: "Claude Sonnet",
              id: "anthropic.claude-3-sonnet-20240229-v1:0",
            },
            {
              name: "Claude Haiku",
              id: "anthropic.claude-3-haiku-20240307-v1:0",
            },
            {
              name: "Claude Sonnet 3.5",
              id: "apac.anthropic.claude-3-5-sonnet-20240620-v1:0",
            },
            {
              name: "Mistral Large",
              id: "mistral.mistral-large-2402-v1:0",
            },
            ...customModels,
          ];
        case "azure_openai":
          return customModels;
        case "groq":
          return [
            {
              name: "Llama 3.1 8b",
              id: "llama-3.1-8b-instant",
            },
            {
              name: "Llama 3.1 70b",
              id: "llama-3.1-70b-versatile",
            },
            {
              name: "Llama 3.3 70b",
              id: "llama-3.3-70b-specdec",
            },
            {
              name: "QwQ-32B-Groq",
              id: "qwen-qwq-32b",
            },
            {
              name: "DeepSeek R1-Groq - Llama 3.3 70b Distill",
              id: "deepseek-r1-distill-llama-70b-specdec",
            },
            ...customModels,
          ];
        default:
          return [
            {
              name: "TF Sorcerer",
              id: "sorcerer",
              plannerAvailable: true,
            },
            {
              name: "TF Sorcerer 1.5 Thinking",
              id: "sorcerer_15",
              plannerAvailable: true,
            },
            {
              name: "TF Mystica",
              id: "mystica",
              plannerAvailable: true,
            },
            {
              name: "TF Mystica 1.5 Thinking",
              id: "mystica_15",
              plannerAvailable: true,
            },
            {
              name: "Qwen 3 235b",
              id: "Qwen/Qwen3-235B-Instruct",
              plannerAvailable: true,
            },
            {
              name: "Qwen 2.5 72b",
              id: "Qwen/Qwen2.5-72B-Instruct-Turbo",
              plannerAvailable: true,
            },
            {
              name: "DeepSeek V3-0324",
              id: "deepseek-ai/DeepSeek-V3",
              plannerAvailable: true,
            },
            {
              name: "Mistral Small 3",
              id: "mistralai/Mistral-Small-24B-Instruct-2501",
              plannerAvailable: true,
            },
            {
              name: "Llama 4 Maverick",
              id: "meta-llama/Llama-4-Maverick",
              plannerAvailable: true,
            },
            {
              name: "Llama 4 Scout",
              id: "meta-llama/Llama-4-Scout",
              plannerAvailable: true,
            },
            {
              name: "Llama 3.3 70b",
              id: "meta-llama/Llama-3.3-70B-Instruct-Turbo",
              plannerAvailable: true,
            },
            {
              name: "Llama 3.1 8b",
              id: "meta-llama/Meta-Llama-3.1-8B-Instruct-Turbo",
              plannerAvailable: false,
            },
            {
              name: "Llama 3.1 70B",
              id: "meta-llama/Meta-Llama-3.1-70B-Instruct-Turbo",
              plannerAvailable: false,
            },
            {
              name: "Llama 3.1 Nemotron 70B",
              id: "nvidia/Llama-3.1-Nemotron-70B-Instruct-HF",
              plannerAvailable: true,
            },
            {
              name: "Llama 3.1 405b (Deprecated)",
              id: "meta-llama/Meta-Llama-3.1-405B-Instruct-Turbo",
              plannerAvailable: false,
            },
            ...finetunedModels,
          ];
      }
    }
    // here I need to load the hosting records so that I can populate the dropdown correctly
    else
      switch (llmProviderType) {
        case "tf":
          const baseModel = [..._baseModels];
          if (
            subscriptionPlan === "pro" ||
            subscriptionPlan === "enterprise" ||
            getActiveWorkspace()?.enableExperimentalFeatures
          ) {
            baseModel.push(..._proModels);
            baseModel.push(...finetunedModels);
          }

          return baseModel;
        case "ollama":
          return modelsAvailable;
        case "aws":
          if (
            subscriptionPlan === "enterprise" ||
            getActiveWorkspace()?.enableExperimentalFeatures
          )
            return [
              {
                name: "Mistral 7b 0.2",
                id: "mistral.mistral-7b-instruct-v0:2",
              },
              {
                name: "Mixtral 8x7b",
                id: "mistral.mixtral-8x7b-instruct-v0:1",
              },
              {
                name: "Mistral Large",
                id: "mistral.mistral-large-2402-v1:0",
              },
              {
                name: "Mistral Large 2",
                id: "mistral.mistral-large-2407-v1:0",
              },
              {
                name: "Claude Sonnet 3.5",
                id: "apac.anthropic.claude-3-5-sonnet-20240620-v1:0",
              },
              {
                name: "Claude Sonnet",
                id: "anthropic.claude-3-sonnet-20240229-v1:0",
              },
              {
                name: "Claude Haiku",
                id: "anthropic.claude-3-haiku-20240307-v1:0",
              },
              ...customModels,
            ];
          else return [];
        case "openai":
          if (
            subscriptionPlan === "enterprise" ||
            getActiveWorkspace()?.enableExperimentalFeatures
          )
            return [
              {
                name: "GPT 4 Omni",
                id: "gpt-4o",
              },
              ...customModels,
            ];
          else return [];
        case "azure_openai":
          if (
            subscriptionPlan === "enterprise" ||
            getActiveWorkspace()?.enableExperimentalFeatures
          )
            return customModels;
          else return [];
        case "together":
          return [
            ..._baseModels?.filter((u) => u?.tfOnly != true),
            ..._proModels,
            ...customModels,
          ];
        case "replicate":
          return [
            {
              name: "Mistral 7b v0.1",
              id: "mistralai/Mistral-7B-Instruct-v0.1",
            },
            {
              name: "Mistral 7b v0.2",
              id: "mistralai/Mistral-7B-Instruct-v0.2",
            },
            {
              name: "Mixtral 8x7b",
              id: "mistralai/Mixtral-8x7B-Instruct-v0.1",
            },
            {
              name: "Llama 3 8b",
              id: "meta/meta-llama-3-8b-instruct",
            },
            {
              name: "Llama 3 70b",
              id: "meta/meta-llama-3-70b-instruct",
            },
            {
              name: "DeepSeek R1 - 0528",
              id: "deepseek-ai/DeepSeek-R1_TF",
            },
            ...customModels,
          ];
        case "groq":
          return [
            {
              name: "Llama 3.1 8b",
              id: "llama-3.1-8b-instant",
            },
            {
              name: "Llama 3.1 70b",
              id: "llama-3.1-70b-versatile",
            },
            {
              name: "Llama 3.3 70b",
              id: "llama-3.3-70b-specdec",
            },
            {
              name: "QwQ-32B-Groq",
              id: "qwen-qwq-32b",
            },
            {
              name: "DeepSeek R1-Groq - Llama 3.3 70b Distill",
              id: "deepseek-r1-distill-llama-70b-specdec",
            },
            ...customModels,
          ];
        case "anthropic":
          return [
            {
              name: "Claude 3 Sonnet",
              id: "claude-3-sonnet-20240229",
            },
            {
              name: "Claude 3 Haiku",
              id: "claude-3-haiku-20240307",
            },
            {
              name: "Claude 3 Opus",
              id: "claude-3-opus-20240229",
            },
            {
              name: "Claude 3.5 Haiku",
              id: "claude-3-5-haiku-20241022",
            },
            {
              name: "Claude 3.5 Sonnet",
              id: "claude-3-5-sonnet-20240620",
            },
            {
              name: "Claude 3.5 Sonnet v2",
              id: "claude-3-5-sonnet-20241022",
            },
            ...customModels,
          ];
        case "google":
          return [
            {
              name: "Gemini 1.5 Pro 002",
              id: "gemini-1.5-pro-002",
            },

            {
              name: "Gemini 1.5 Flash 002",
              id: "gemini-1.5-flash-002",
            },
            {
              name: "Gemini 1.5 Pro Experimental",
              id: "gemini-exp-1121",
            },
            {
              name: "Gemini 2.0 Flash",
              id: "gemini-2.0-flash-exp",
            },
            ...customModels,
          ];
        case "local":
          return [...customModels];

        default:
          const baseModels = [..._baseModels];
          if (
            subscriptionPlan === "pro" ||
            subscriptionPlan === "enterprise" ||
            getActiveWorkspace()?.enableExperimentalFeatures
          ) {
            baseModels.push(..._proModels);
            baseModels.push(...finetunedModels);
          }

          return baseModels;
      }
  };
  const colourStyles = {
    control: (styles) => ({
      ...styles,
      backgroundColor: currentTheme?.theme?.inputBackgroundColor,
      borderColor: currentTheme?.theme?.border_color,
      fontFamily: "normalFont",
      fontSize: currentTheme?.theme?.small_font_size,
    }),
    option: (styles, { data, isDisabled, isFocused, isSelected }) => {
      let color = new Color(data?.backgroundColor || currentTheme?.theme?.grey);
      return {
        ...styles,
        backgroundColor: isDisabled
          ? undefined
          : isSelected
          ? color
          : isFocused
          ? color.alpha(0.1).css()
          : undefined,
        color: isDisabled
          ? "#ccc"
          : isSelected
          ? currentTheme?.theme?.white
            ? "white"
            : "black"
          : data?.backgroundColor,
        cursor: isDisabled ? "not-allowed" : "default",

        ":active": {
          ...styles[":active"],
          backgroundColor: !isDisabled
            ? isSelected
              ? data?.backgroundColor
              : color.alpha(0.3).css()
            : undefined,
        },
      };
    },
    multiValue: (styles, { data }) => {
      let color = new Color(data?.backgroundColor || currentTheme?.theme?.grey);
      return {
        ...styles,
        backgroundColor: color.alpha(0.1).css(),
      };
    },
    multiValueLabel: (styles, { data }) => ({
      ...styles,
      color: data?.backgroundColor,
    }),
    multiValueRemove: (styles, { data }) => ({
      ...styles,
      color: data?.backgroundColor,
      ":hover": {
        backgroundColor: data?.backgroundColor,
        color: "white",
      },
    }),
    menu: (styles) => ({
      ...styles,
      backgroundColor: currentTheme?.theme?.inputBackgroundColor,
      borderColor: currentTheme?.theme?.lightGray,
      fontFamily: "normalFont",
      fontSize: currentTheme?.theme?.small_font_size,
    }),
  };

  return (
    <AppToast.ToastProvider
      {...AppConfig.notificationConfig}
      // offset for both top and bottom toasts..
    >
      <View
        style={{
          zIndex: -1,
        }}
      >
        {isChatBot && (
          <ImagePlaceholder
            onFileSelection={handleIconSelection}
            imagePath={agentImage}
            isFileUploadInProgress={fileUploadInProgress}
            fileUploadProgress={fileUploadProgress}
          />
        )}

        {isEdit && (
          <AdminInfoLeaf
            wrapperStyle={{
              alignSelf: "flex-start",
              marginBottom: 10,
            }}
            textContainer={{
              marginLeft: 5,
              marginTop: 10,
              marginBottom: 0,
            }}
            titleStyle={{
              marginTop: 0,
              marginLeft: 10,
            }}
            textStyle={{
              marginLeft: 0,
            }}
            title={"ID"}
            value={initialMapValues?.id}
            width={420}
          />
        )}
        <View>
          <AppForms.AppFormField
            showTextInputLabel
            isMandatory
            wrapperInputStyle={{
              paddingTop: 10,
            }}
            label={`Name`}
            placeholder={`Agent name`}
            keyboardtype="default"
            textContextType="label"
            autoCorrect={false}
            name="label"
          />
        </View>
        <View>
          <AppForms.AppFormField
            showTextInputLabel
            wrapperInputStyle={{
              paddingTop: 10,
            }}
            textContainer={{
              // minHeight: 120,
              paddingVertical: 10,
            }}
            multiline={false}
            label={`Domain`}
            placeholder={`subject_name_placeholder`}
            keyboardtype="default"
            textContextType="label"
            autoCorrect={false}
            name="subject"
          />
        </View>
        {values?.mode != null && values?.mode != "planner" && (
          <View>
            <AppForms.AppFormField
              showTextInputLabel
              wrapperInputStyle={{
                paddingTop: 10,
              }}
              textContainer={{
                minHeight: 120,
                paddingVertical: 10,
              }}
              multiline={true}
              label={`Agent description`}
              placeholder={`agent_description_placeholder`}
              keyboardtype="default"
              textContextType="label"
              autoCorrect={false}
              name="description"
            />
          </View>
        )}
        <View>
          {isChatBot && (
            <View>
              <AppForms.AppFormDropDown
                isElevated={false}
                dropDownStyle={{
                  borderColor: currentTheme?.theme?.border_color,
                  maxWidth: !isLargeScreen() && 250,
                }}
                showTextInputLabel
                label="Mode"
                isMandatory
                name="mode"
                items={_modes}
                propertyLabel="name"
                propertyValue="id"
                disabled={isEdit}
              />
              <AppText
                leftIcon={AppAssets?.icons?.info}
                wrapperStyle={{
                  paddingHorizontal: 10,
                }}
                color={currentTheme?.theme?.orange}
                style={{
                  marginLeft: 10,
                }}
                iconSize={14}
              >
                {
                  generateModes()?.find((u) => u?.id == values?.mode)
                    ?.description
                }
              </AppText>
            </View>
          )}

          {values?.mode === "custom" && (
            <AppForms.AppFormDropDown
              isElevated={false}
              dropDownStyle={{
                borderColor: currentTheme?.theme?.border_color,
                maxWidth: !isLargeScreen() && 250,
              }}
              showTextInputLabel
              label="Overview"
              isMandatory
              name="qaUrl"
              items={
                [
                  { name: "Default", propertyValue: "default_qa_model" },
                  ...getTrainingLogsWithModels("readComprehensionTraining"),
                ] || []
              }
              propertyLabel="name"
              propertyValue="id"
            />
          )}
        </View>
        {isKnowledgeEnabled && (
          <>
            {isChatBot && values?.mode != "coder" && (
              <View>
                <AppForms.AppFormSwitch
                  wrapperStyle={[
                    {
                      backgroundColor: isEdit
                        ? currentTheme?.theme?.grey
                        : currentTheme?.theme?.lightGrey,
                      maxHeight: 30,
                      paddingHorizontal: 10,

                      paddingVertical: 18,
                      margin: 5,
                      marginTop: 10,
                    },
                  ]}
                  labelTextStyle={{
                    fontSize: currentTheme?.theme?.small_font_size,
                    color: currentTheme?.theme?.darkGrey,
                  }}
                  showTextInputLabel={true}
                  label={"Step by step reasoning"}
                  displayIsTicked={true}
                  name="blender"
                  value={values?.blender}
                  disabled={
                    values?.hasTopicsContext != true &&
                    values?.hasFunctions != true
                  }
                />
                <AppForms.AppFormSwitch
                  wrapperStyle={[
                    {
                      backgroundColor: isEdit
                        ? currentTheme?.theme?.grey
                        : currentTheme?.theme?.lightGrey,
                      maxHeight: 30,
                      paddingHorizontal: 10,

                      paddingVertical: 18,
                      margin: 5,
                      marginTop: 10,
                    },
                  ]}
                  labelTextStyle={{
                    fontSize: currentTheme?.theme?.small_font_size,
                    color: currentTheme?.theme?.darkGrey,
                  }}
                  showTextInputLabel={true}
                  label={"Cross document analysis"}
                  displayIsTicked={true}
                  name="chainOfThoughts"
                  value={values?.chainOfThoughts}
                  disabled={
                    values?.hasTopicsContext != true &&
                    values?.hasFunctions != true
                  }
                />
              </View>
            )}
          </>
        )}
        {isChatBot &&
          values?.mode == "coder" &&
          !isAgentOllama &&
          getActiveWorkspace()?.subscriptionType != "base" && (
            <View>
              <AppForms.AppFormSwitch
                wrapperStyle={[
                  {
                    backgroundColor: isEdit
                      ? currentTheme?.theme?.grey
                      : currentTheme?.theme?.lightGrey,
                    maxHeight: 30,
                    paddingHorizontal: 10,

                    paddingVertical: 18,
                    margin: 5,
                    marginTop: 10,
                  },
                ]}
                labelTextStyle={{
                  fontSize: currentTheme?.theme?.small_font_size,
                  color: currentTheme?.theme?.darkGrey,
                }}
                showTextInputLabel={true}
                label={"Code execution"}
                displayIsTicked={true}
                name="hasCode"
                value={values?.hasCode}
                disabled={false}
              />
              <AppForms.AppFormSwitch
                wrapperStyle={[
                  {
                    backgroundColor: isEdit
                      ? currentTheme?.theme?.grey
                      : currentTheme?.theme?.lightGrey,
                    maxHeight: 30,
                    paddingHorizontal: 10,

                    paddingVertical: 18,
                    margin: 5,
                    marginTop: 20,
                  },
                ]}
                labelTextStyle={{
                  fontSize: currentTheme?.theme?.small_font_size,
                  color: currentTheme?.theme?.darkGrey,
                }}
                showTextInputLabel={true}
                label={"Code upload"}
                displayIsTicked={true}
                name="allowDocsUpload"
                value={values?.allowDocsUpload}
                disabled={codeUploadDisabled}
              />

              <AppForms.AppFormSwitch
                wrapperStyle={[
                  {
                    backgroundColor: isEdit
                      ? currentTheme?.theme?.grey
                      : currentTheme?.theme?.lightGrey,
                    maxHeight: 30,
                    paddingHorizontal: 10,

                    paddingVertical: 18,
                    margin: 5,
                    marginTop: 20,
                  },
                ]}
                labelTextStyle={{
                  fontSize: currentTheme?.theme?.small_font_size,
                  color: currentTheme?.theme?.darkGrey,
                }}
                showTextInputLabel={true}
                label={"Allow external API requests"}
                displayIsTicked={true}
                name="allowExternalAPI"
                value={values?.allowExternalAPI}
                disabled={!values?.hasCode}
              />
            </View>
          )}

        <View>
          {isChatBot &&
            values?.mode == "coder" &&
            values?.hasCode &&
            !isAgentOllama && (
              <View
                style={{
                  zIndex: 10000,
                }}
              >
                <AppExpander
                  expanderStyle={{
                    zIndex: 10000,
                  }}
                  style={{ minWidth: 250, zIndex: 20 }}
                  isExpandedOnLoad={true}
                  title="Execution environments settings"
                  icon={AppAssets.icons.code}
                >
                  <View
                    style={{
                      paddingLeft: 10,
                      zIndex: 20,
                    }}
                  >
                    <AppForms.AppFormMultiSelect
                      name="customCodeExecutionEnvironments"
                      placeholder="Assign code environments"
                      hidePlaceholder={true}
                      items={customCodeExecutionEnvironments}
                      uniqueKey="id"
                      showDropDowns={true}
                      readOnlyHeadings={true}
                      labelOption="name"
                      groupByProperty="type"
                      style={{ maxWidth: 800 }}
                      wrapperContainerStyle={{
                        flex: !isLargeScreen() ? 1 : 0.5,
                        zIndex: 20,
                        paddingTop: 10,
                        marginBottom: 30,
                      }}
                      styles={colourStyles}
                      options={customCodeExecutionEnvironments?.map((u) => {
                        return {
                          ...u,
                          label:
                            u?.name +
                            " - " +
                            Utility?.mapFunctionTypeToLabel("chat"),
                          value: u?.id,
                          backgroundColor: Utility?.mapFunctionTypeToColour(
                            u,
                            currentTheme
                          ),
                        };
                      })}
                    />
                  </View>
                  <AppText
                    style={{
                      paddingLeft: 5,

                      fontSize: currentTheme?.theme?.extra_small_font_size,
                    }}
                    wrapperStyle={{
                      top: -10,
                      justifyContent: "center",
                    }}
                    iconSize={12}
                    leftIcon={AppAssets?.icons?.question_icon}
                  >
                    Only one environment can be used at a each turn depending on
                    the code function used.
                  </AppText>
                </AppExpander>
              </View>
            )}
          {values?.hasTopicsContext && isKnowledgeEnabled && !isAgentOllama && (
            <AppExpander
              style={{ minWidth: 250 }}
              isExpandedOnLoad={true}
              title="Knowledge settings"
              icon={AppAssets.icons.notes}
            >
              <View
                style={{
                  paddingLeft: 10,
                }}
              >
                <AppForms.AppFormMultiSelect
                  showTextInputLabel
                  inputLabelStyle={{
                    marginLeft: 10,
                    marginBottom: 10,
                  }}
                  label="Assign Topics"
                  name="allowedTopics"
                  topErrorOffset={-21}
                  touchedByDefault
                  placeholder="Assign topics"
                  hidePlaceholder={true}
                  items={_topics}
                  uniqueKey="id"
                  showDropDowns={true}
                  readOnlyHeadings={true}
                  labelOption="label"
                  groupByProperty="type"
                  style={{ maxWidth: 800 }}
                  maxSelectedValues={10}
                  onError={(error) => {
                    AppToasty.show(
                      "You reached the maximum number of allowed topics",
                      {
                        type: "warning",
                      }
                    );
                  }}
                  wrapperContainerStyle={{
                    zIndex: 20,
                    paddingTop: 10,
                    paddingBottom: 10,
                  }}
                  styles={colourStyles}
                  options={_topics.map((u) => {
                    return {
                      ...u,
                      value: u?.id,
                    };
                  })}
                />
                <AppText
                  style={{
                    paddingLeft: 5,

                    fontSize: currentTheme?.theme?.extra_small_font_size,
                  }}
                  wrapperStyle={{
                    marginTop: values?.allowedTopics?.length > 0 ? 0 : 0,
                    marginBottom: values?.allowedTopics?.length > 0 ? 5 : 30,
                    justifyContent: "flex-start",
                  }}
                  iconSize={12}
                  leftIcon={AppAssets?.icons?.question_icon}
                >
                  {values?.allowedTopics?.length >= 10
                    ? "You reached the max number of topics"
                    : "Select up to 10 topics"}
                </AppText>
                {values?.allowedTopics && values?.allowedTopics?.length > 0 && (
                  <View
                    style={{
                      zIndex: 10,
                    }}
                  >
                    <AppForms.AppFormMultiSelect
                      showTextInputLabel
                      inputLabelStyle={{
                        marginLeft: 10,
                        marginBottom: 10,
                      }}
                      label="Assign Static Docs"
                      name="staticDocs"
                      topErrorOffset={-21}
                      touchedByDefault
                      placeholder="Assign static docs to retrieve"
                      hidePlaceholder={true}
                      items={filteredDocs}
                      options={filteredDocs.map((u) => {
                        return {
                          ...u,
                          value: u?.id,
                        };
                      })}
                      uniqueKey="id"
                      showDropDowns={true}
                      readOnlyHeadings={true}
                      labelOption="title"
                      groupByProperty="embedding_status"
                      style={{ maxWidth: 800 }}
                      wrapperContainerStyle={{
                        zIndex: 10,
                        paddingTop: 10,
                        marginBottom: 0,
                      }}
                      styles={colourStyles}
                      maxSelectedValues={5}
                      onError={(error) => {
                        AppToasty.show(
                          "You reached the maximum number of static documents",
                          {
                            type: "warning",
                          }
                        );
                      }}
                    />
                    <AppText
                      style={{
                        paddingLeft: 5,

                        fontSize: currentTheme?.theme?.extra_small_font_size,
                      }}
                      wrapperStyle={{
                        marginTop: 10,
                        marginBottom: 30,
                        justifyContent: "flex-start",
                      }}
                      iconSize={12}
                      leftIcon={AppAssets?.icons?.question_icon}
                    >
                      {values?.staticDocs?.length >= 5
                        ? "You reached the max number of static docs"
                        : "Select up to 5 static docs"}
                    </AppText>
                  </View>
                )}

                <View
                  style={{
                    paddingBottom: 20,
                    marginTop: -40,
                  }}
                >
                  <AppForms.AppFormSwitch
                    // disabled={isEdit}
                    wrapperStyle={[
                      {
                        backgroundColor: isEdit
                          ? currentTheme?.theme?.grey
                          : currentTheme?.theme?.lightGrey,
                        maxHeight: 30,
                        paddingHorizontal: 10,

                        paddingVertical: 18,
                        margin: 5,
                        marginTop: 20,
                      },
                    ]}
                    labelTextStyle={{
                      fontSize: currentTheme?.theme?.small_font_size,
                      color: currentTheme?.theme?.darkGrey,
                    }}
                    showTextInputLabel={true}
                    label={"Keywords for knowledge base query"}
                    displayIsTicked={true}
                    name="keyWordsForKnowledgeBase"
                    value={values?.keyWordsForKnowledgeBase}
                  />
                </View>
                {isChatBot && (
                  <View
                    style={{
                      marginLeft: 20,
                    }}
                  >
                    <AppForms.AppFormSlider
                      step={1}
                      maximumValue={
                        values?.mode === "coder" || values?.mode === "chatter"
                          ? 10
                          : 5
                      }
                      minimumValue={1}
                      label="Max history"
                      name="maxHistory"
                      showEditButtons={true}
                    />
                  </View>
                )}

                <View
                  style={{
                    marginLeft: 20,
                  }}
                >
                  <AppForms.AppFormSlider
                    step={1}
                    maximumValue={
                      isBusinessAnalyst
                        ? getActiveWorkspace()
                            ?.isExtendedBusinessAnalystReportEnabled
                          ? 50
                          : 25
                        : 20
                    }
                    minimumValue={1}
                    label="TopK"
                    name="topK"
                    showEditButtons={true}
                  />
                </View>
                <View
                  style={{
                    marginLeft: 20,
                  }}
                >
                  <AppForms.AppFormSlider
                    step={1}
                    maximumValue={
                      isBusinessAnalyst
                        ? getActiveWorkspace()
                            ?.isExtendedBusinessAnalystReportEnabled
                          ? 50
                          : 25
                        : 20
                    }
                    minimumValue={1}
                    label="Doc TopK"
                    name="docTopK"
                    showEditButtons={true}
                  />
                </View>
                <View
                  style={{
                    marginLeft: 20,
                  }}
                >
                  <AppForms.AppFormSlider
                    step={0.01}
                    maximumValue={0.99}
                    minimumValue={0.01}
                    label="Min retrieval accuracy"
                    name="minRetrievalScore"
                  />
                  <AppForms.AppFormSlider
                    step={1}
                    maximumValue={5}
                    minimumValue={0}
                    label="Recency importance"
                    name="recencyImportance"
                  />

                  <AppForms.AppFormSlider
                    step={0.01}
                    maximumValue={1}
                    minimumValue={0.01}
                    label="In-context retrieval ratio"
                    name="contextRelevancyRatio"
                    showEditButtons={true}
                  />

                  <AppForms.AppFormSlider
                    step={1}
                    maximumValue={5}
                    minimumValue={0}
                    label="Keywords importance"
                    name="keywordsWeightInRetrieval"
                  />
                </View>

                {isBusinessAnalyst &&
                  getActiveWorkspace()
                    ?.isExtendedBusinessAnalystReportEnabled && (
                    <View
                      style={{
                        marginLeft: 0,
                      }}
                    >
                      <AppForms.AppFormSwitch
                        // disabled={isEdit}
                        // disabled={true}
                        wrapperStyle={[
                          {
                            backgroundColor: isEdit
                              ? currentTheme?.theme?.grey
                              : currentTheme?.theme?.lightGrey,
                            maxHeight: 30,
                            paddingHorizontal: 10,

                            paddingVertical: 18,
                            margin: 5,
                          },
                        ]}
                        labelTextStyle={{
                          fontSize: currentTheme?.theme?.small_font_size,
                          color: currentTheme?.theme?.darkGrey,
                        }}
                        showTextInputLabel={true}
                        label={"Extended report"}
                        displayIsTicked={true}
                        name="generateExtendedReport"
                        value={values?.generateExtendedReport}
                      />
                    </View>
                  )}
              </View>
            </AppExpander>
          )}
        </View>
        {isChatBot &&
          isKnowledgeEnabled &&
          values?.mode != "coder" &&
          !isAgentOllama && (
            <View
              style={{
                zIndex: 10000,
              }}
            >
              <AppExpander
                expanderStyle={{
                  zIndex: 10000,
                }}
                style={{ minWidth: 250, zIndex: 20 }}
                isExpandedOnLoad={false}
                title="Functions settings"
                icon={AppAssets.icons.agentFunction}
              >
                <View
                  style={{
                    paddingLeft: 10,
                    zIndex: 20,
                  }}
                >
                  <AppForms.AppFormMultiSelect
                    showTextInputLabel
                    inputLabelStyle={{
                      marginBottom: 10,
                      marginLeft: 7,
                    }}
                    label="Functions"
                    name="agentFunctions"
                    placeholder="Assign functions for this agent to use"
                    hidePlaceholder={true}
                    items={availableFunctions}
                    uniqueKey="id"
                    showDropDowns={true}
                    readOnlyHeadings={true}
                    labelOption="name"
                    groupByProperty="type"
                    style={{ maxWidth: 800 }}
                    wrapperContainerStyle={{
                      flex: !isLargeScreen() ? 1 : 0.5,
                      zIndex: 20,
                      paddingTop: 10,
                      marginLeft: 10,
                      marginBottom: 40,
                    }}
                    styles={colourStyles}
                    options={availableFunctions.map((u) => {
                      return {
                        ...u,
                        label:
                          u?.name + " - " + Utility?.mapFunctionTypeToLabel(u),
                        value: u?.id,
                        backgroundColor: Utility?.mapFunctionTypeToColour(
                          u,
                          currentTheme
                        ),
                      };
                    })}
                  />

                  <AppForms.AppFormFieldJSONV2
                    showTextInputLabel
                    wrapperInputStyle={{
                      paddingTop: 0,
                    }}
                    errorMessageTopOffset={-18}
                    wrapperContainer={{
                      height: 250,
                      paddingTop: 10,
                    }}
                    // change
                    mode="code"
                    // schema={validations.parametersVal}
                    label={`Agent parameters`}
                    name="agentFnParams"
                    darkMode={mode === "dark"}
                  />
                </View>
                <View
                  style={{
                    paddingLeft: 10,
                    zIndex: 10,
                    paddingBottom: 40,
                    marginTop: -20,
                  }}
                >
                  <AppForms.AppFormMultiSelect
                    showTextInputLabel
                    inputLabelStyle={{
                      marginBottom: 10,
                      marginLeft: 7,
                    }}
                    label="Context"
                    name="functionContext"
                    topErrorOffset={-21}
                    touchedByDefault
                    placeholder="Assign context to function calling"
                    hidePlaceholder={true}
                    items={_functionContext}
                    uniqueKey="id"
                    showDropDowns={true}
                    readOnlyHeadings={true}
                    labelOption="label"
                    groupByProperty="type"
                    style={{ maxWidth: 800 }}
                    wrapperContainerStyle={{
                      flex: !isLargeScreen() ? 1 : 0.5,
                      zIndex: 20,
                      marginLeft: 8,
                      marginTop: -25,
                    }}
                    styles={colourStyles}
                    options={_functionContext.map((u) => {
                      return {
                        ...u,
                        value: u?.id,
                      };
                    })}
                  />
                </View>
              </AppExpander>
            </View>
          )}

        {isChatBot &&
          isKnowledgeEnabled &&
          values?.mode != "coder" &&
          getActiveWorkspace()?.subscriptionType != "base" && (
            <AppExpander
              style={{ minWidth: 250, zIndex: -1 }}
              title="Internet search"
              icon={AppAssets.icons.network}
            >
              <AppForms.AppFormSwitch
                wrapperStyle={[
                  {
                    backgroundColor: isEdit
                      ? currentTheme?.theme?.grey
                      : currentTheme?.theme?.lightGrey,
                    maxHeight: 30,
                    paddingHorizontal: 10,

                    paddingVertical: 18,
                    marginHorizontal: 5,
                    marginVertical: 20,
                  },
                ]}
                labelTextStyle={{
                  fontSize: currentTheme?.theme?.small_font_size,
                  color: currentTheme?.theme?.darkGrey,
                }}
                showTextInputLabel={true}
                label={"Allow internet search"}
                displayIsTicked={true}
                name="allowInternetSearch"
                value={values?.allowInternetSearch}
              />
              <View
                style={{
                  paddingLeft: 0,
                  zIndex: 20,
                }}
              >
                <AppForms.AppFormMultiSelect
                  name="internetSearchModes"
                  placeholder="Select search modes"
                  hidePlaceholder={true}
                  items={[
                    {
                      label: "search",
                      value: "search",
                      backgroundColor: currentTheme?.theme?.primary,
                    },
                    {
                      label: "news",
                      value: "news",
                      backgroundColor: currentTheme?.theme?.green,
                    },
                    {
                      label: "images",
                      value: "images",
                      backgroundColor: currentTheme?.theme?.orange,
                    },
                    {
                      label: "shopping",
                      value: "shopping",
                      backgroundColor: currentTheme?.theme?.purple,
                    },
                    {
                      label: "videos",
                      value: "videos",
                      backgroundColor: currentTheme?.theme?.red,
                    },
                  ]}
                  uniqueKey="value"
                  showDropDowns={true}
                  readOnlyHeadings={true}
                  labelOption="name"
                  groupByProperty="type"
                  style={{ maxWidth: 800 }}
                  wrapperContainerStyle={{
                    flex: !isLargeScreen() ? 1 : 0.5,
                    zIndex: 20,
                    paddingTop: 10,
                    marginBottom: 30,
                    paddingHorizontal: 3,
                  }}
                  styles={colourStyles}
                  options={[
                    {
                      label: "search",
                      value: "search",
                      backgroundColor: currentTheme?.theme?.primary,
                    },
                    {
                      label: "news",
                      value: "news",
                      backgroundColor: currentTheme?.theme?.green,
                    },
                    {
                      label: "images",
                      value: "images",
                      backgroundColor: currentTheme?.theme?.orange,
                    },
                    {
                      label: "shopping",
                      value: "shopping",
                      backgroundColor: currentTheme?.theme?.purple,
                    },
                    {
                      label: "videos",
                      value: "videos",
                      backgroundColor: currentTheme?.theme?.red,
                    },
                  ]}
                />
                <AppForms.AppFormDropDown
                  isElevated={false}
                  dropDownStyle={{
                    borderColor: currentTheme?.theme?.border_color,
                    maxWidth: !isLargeScreen() && 250,
                  }}
                  showTextInputLabel
                  label="Internet search location"
                  isMandatory
                  name="internetSearchLocation"
                  items={internetSearchLocations?.map((u) => {
                    {
                      return {
                        ...u,
                        id: u?.name,
                      };
                    }
                  })}
                  propertyLabel="name"
                  propertyValue="id"
                />
              </View>
              <View
                style={{
                  marginLeft: 15,
                  paddingLeft: 0,
                }}
              >
                <AppForms.AppFormSlider
                  step={1}
                  maximumValue={10}
                  minimumValue={1}
                  label="Max search results"
                  name="maxUrlsForInternetSearch"
                  showEditButtons={true}
                />
              </View>

              <AppForms.AppFormField
                showTextInputLabel
                wrapperInputStyle={{
                  paddingTop: 10,
                }}
                multiline={true}
                textContainer={{
                  minHeight: 120,
                  paddingVertical: 10,
                  marginHorizontal: 5,
                }}
                errorOffset={0}
                label={`Excluded domains from search`}
                placeholder={`Insert the domains you do not want to include in the search seperated by a comma (e.g. https://www.example.com,https://www.example2.com)`}
                keyboardtype="default"
                textContextType="label"
                autoCorrect={false}
                name="bannedDomains"
                textInputLabelStyle={{
                  marginLeft: 15,
                }}
              />
              <AppForms.AppFormSwitch
                wrapperStyle={[
                  {
                    backgroundColor: isEdit
                      ? currentTheme?.theme?.grey
                      : currentTheme?.theme?.lightGrey,
                    maxHeight: 30,
                    paddingHorizontal: 10,

                    paddingVertical: 18,
                    marginHorizontal: 5,
                    marginVertical: 20,
                  },
                ]}
                labelTextStyle={{
                  fontSize: currentTheme?.theme?.small_font_size,
                  color: currentTheme?.theme?.darkGrey,
                }}
                showTextInputLabel={true}
                label={"Allow deep search"}
                displayIsTicked={true}
                name="allowDeepInternetSearch"
                value={values?.allowDeepInternetSearch}
              />
            </AppExpander>
          )}
        <View
          style={{
            zIndex: -1,
          }}
        >
          {isChatBot && isCharacterNeeded && values?.mode != "planner" && (
            <AppExpander
              expanderStyle={{
                zIndex: -1,
              }}
              style={{ minWidth: 250, zIndex: -1 }}
              title="Agent instructions"
              icon={AppAssets.icons.persona}
            >
              <View
                style={{
                  paddingLeft: 10,
                }}
              >
                <View>
                  <AppForms.AppFormField
                    showTextInputLabel
                    isMandatory
                    wrapperInputStyle={{
                      paddingTop: 10,
                    }}
                    textContainer={{
                      minHeight: 480,
                      paddingVertical: 10,
                    }}
                    multiline={true}
                    label={`Agent role and instructions`}
                    placeholder={`Interpolation_role_placeholder`}
                    keyboardtype="default"
                    textContextType="label"
                    autoCorrect={false}
                    name="interpolationString"
                  />
                  {values?.mode != "planner" && !isAgentOllama && (
                    <>
                      <AppForms.AppFormField
                        showTextInputLabel
                        wrapperInputStyle={{
                          paddingTop: 10,
                        }}
                        formFieldContainerStyle={{
                          zIndex: 10,
                        }}
                        textContainer={{
                          minHeight: 120,
                          paddingVertical: 10,
                        }}
                        multiline={true}
                        label={`Agent tooling guidelines`}
                        placeholder={`guidelines_placeholder`}
                        keyboardtype="default"
                        textContextType="label"
                        autoCorrect={false}
                        name="customToolingInstructions"
                        maxMentionsMenuHeight={390}
                        mentioning
                        mentions={_tools
                          ?.filter(
                            (u) =>
                              u?.id != "deep_thinking" ||
                              (u?.id == "deep_thinking" &&
                                ["sorcerer_15", "mystica_15"].includes(
                                  values?.llmBaseModel
                                ))
                          )
                          ?.map((i) => {
                            return {
                              id: i.id,
                              label: i.id,
                            };
                          })}
                        onMentionSelect={(mention) => console.log(mention)}
                      />
                      {values?.mode == "retriever" && (
                        <AppForms.AppFormField
                          showTextInputLabel
                          wrapperInputStyle={{
                            paddingTop: 10,
                          }}
                          textContainer={{
                            minHeight: 120,
                            paddingVertical: 10,
                          }}
                          multiline={true}
                          label={`No data sources answer`}
                          placeholder={`no_knowledge_placeholder`}
                          keyboardtype="default"
                          textContextType="label"
                          autoCorrect={false}
                          name="noKnowledgeDefaultAnswer"
                        />
                      )}
                    </>
                  )}
                </View>
                <View
                  style={{
                    zIndex: -1,
                  }}
                >
                  <AppForms.AppFormField
                    showTextInputLabel
                    wrapperInputStyle={{
                      paddingTop: 10,
                    }}
                    textContainer={{
                      minHeight: 120,
                      paddingVertical: 10,
                    }}
                    multiline={true}
                    label={`Default answer`}
                    placeholder={`default_answer_placeholder`}
                    keyboardtype="default"
                    textContextType="label"
                    autoCorrect={false}
                    name="defaultAnswer"
                  />
                </View>
                <View
                  style={{
                    zIndex: -1,
                  }}
                >
                  <AppForms.AppFormField
                    showTextInputLabel
                    wrapperInputStyle={{
                      paddingTop: 10,
                    }}
                    multiline={true}
                    textContainer={{
                      minHeight: 240,
                      paddingVertical: 10,
                    }}
                    label={`Goals`}
                    placeholder={`goals_passage_placeholder`}
                    keyboardtype="default"
                    textContextType="label"
                    autoCorrect={false}
                    name="goals"
                  />
                </View>

                <View>
                  <AppForms.AppFormField
                    showTextInputLabel
                    wrapperInputStyle={{
                      paddingTop: 10,
                    }}
                    multiline={true}
                    textContainer={{
                      minHeight: 120,
                      paddingVertical: 10,
                    }}
                    label={`Inhibition passage`}
                    placeholder={`inhibition_passage_placeholder`}
                    keyboardtype="default"
                    textContextType="label"
                    autoCorrect={false}
                    name="inhibitionPassage"
                  />
                </View>
                <View>
                  <AppForms.AppFormField
                    showTextInputLabel
                    wrapperInputStyle={{
                      paddingTop: 10,
                    }}
                    multiline={true}
                    textContainer={{
                      minHeight: 120,
                      paddingVertical: 10,
                    }}
                    label={`Pertinance passage`}
                    placeholder={`pertinance_passage_placeholder`}
                    keyboardtype="default"
                    textContextType="label"
                    autoCorrect={false}
                    name="pertinencePassage"
                  />
                </View>
              </View>
            </AppExpander>
          )}
          {isChatBot && values?.mode == "computer" && (
            <AppExpander
              expanderStyle={{
                zIndex: -1,
              }}
              style={{ minWidth: 250, zIndex: -1 }}
              title="Desktop setup and credentials"
              icon={AppAssets.icons.credentials}
            >
              <View
                style={{
                  paddingLeft: 0,
                }}
              >
                <View>
                  <AppForms.AppFormDropDown
                    isElevated={false}
                    dropDownStyle={{
                      borderColor: currentTheme?.theme?.border_color,
                      maxWidth: !isLargeScreen() && 250,
                    }}
                    showTextInputLabel
                    label="Available Virtual Desktops"
                    isMandatory
                    name="vms"
                    items={
                      state?.vms?.length > 0
                        ? [{ id: "none", name: "None" }, ...state?.vms]
                        : [{ id: "none", name: "None" }]
                    }
                    propertyLabel="name"
                    propertyValue="id"
                    _onValueChange={(v) => {
                      if (v != "none") {
                        setFieldValue(
                          "agentDesktopVM",
                          state?.vms?.find((u) => u?.id == v)?.ip
                        );
                        setFieldValue(
                          "agentDesktopPortRange",
                          state?.vms?.find((u) => u?.id == v)?.port
                        );
                      } else {
                        setFieldValue("agentDesktopVM", "");
                        setFieldValue("agentDesktopPortRange", "");
                      }
                    }}
                  />
                  <AppForms.AppFormField
                    showTextInputLabel
                    wrapperInputStyle={{
                      paddingTop: 10,
                    }}
                    isMandatory
                    multiline={false}
                    label={`Virtual desktop IP address`}
                    placeholder={`IP address of the virtual desktop to use (e.g. 192.168.1.1)`}
                    keyboardtype="default"
                    textContextType="label"
                    autoCorrect={false}
                    name="agentDesktopVM"
                    editable={false}
                  />
                  <AppText
                    style={{
                      paddingLeft: 5,

                      fontSize: currentTheme?.theme?.extra_small_font_size,
                    }}
                    wrapperStyle={{
                      top: -10,
                      justifyContent: "center",
                      marginLeft: 10,
                    }}
                    iconSize={12}
                    leftIcon={AppAssets?.icons?.question_icon}
                  >
                    Virtual desktop IP addresses can only be provided by the
                    ToothFairyAI team. Get in touch with us to get Virtual
                    Desktop IP addresses.
                  </AppText>
                </View>
                <View>
                  <AppForms.AppFormField
                    showTextInputLabel
                    wrapperInputStyle={{
                      paddingTop: 10,
                    }}
                    isMandatory
                    multiline={false}
                    label={`Virtual desktop port`}
                    placeholder={`Port of the virtual desktop to use (default 5050)`}
                    keyboardtype="default"
                    textContextType="label"
                    autoCorrect={false}
                    name="agentDesktopPortRange"
                    editable={false}
                  />
                </View>
                <AppForms.AppFormSwitch
                  // disabled={isEdit}
                  // disabled={true}
                  wrapperStyle={[
                    {
                      backgroundColor: isEdit
                        ? currentTheme?.theme?.grey
                        : currentTheme?.theme?.lightGrey,
                      maxHeight: 30,
                      paddingHorizontal: 10,

                      paddingVertical: 18,
                      margin: 5,
                      marginBottom: 10,
                    },
                  ]}
                  labelTextStyle={{
                    fontSize: currentTheme?.theme?.small_font_size,
                    color: currentTheme?.theme?.darkGrey,
                  }}
                  showTextInputLabel={true}
                  label={"Browser only"}
                  displayIsTicked={true}
                  name="agentDesktopBrowser"
                  value={values?.agentDesktopBrowser}
                />

                <AppForms.AppFormMultiSelect
                  name="agentDesktopCredentials"
                  topErrorOffset={-21}
                  touchedByDefault
                  placeholder="Credentials to access third-party apps"
                  hidePlaceholder={true}
                  items={_authorisations}
                  uniqueKey="id"
                  showDropDowns={true}
                  readOnlyHeadings={true}
                  labelOption="label"
                  groupByProperty="type"
                  style={{ maxWidth: 800 }}
                  wrapperContainerStyle={{
                    flex: !isLargeScreen() ? 1 : 0.5,
                    zIndex: 20,
                    paddingTop: 10,
                    marginBottom: 40,
                    marginHorizontal: 5,
                  }}
                  styles={colourStyles}
                  options={_authorisations.map((u) => {
                    return {
                      ...u,
                      value: u?.id,
                    };
                  })}
                />
                <AppText
                  style={{
                    paddingLeft: 5,

                    fontSize: currentTheme?.theme?.extra_small_font_size,
                  }}
                  wrapperStyle={{
                    top: -10,
                    justifyContent: "center",
                    marginLeft: 10,
                  }}
                  iconSize={12}
                  leftIcon={AppAssets?.icons?.question_icon}
                >
                  The credentials will be used by the Desktop agent to
                  accomplish the task assigned as required. We strongly
                  recommend to create dedicated credentials for any Desktop
                  agent with limited access to third-paty apps.
                </AppText>
              </View>
            </AppExpander>
          )}
          {isChatBot &&
            isCharacterNeeded &&
            !isAgentOllama &&
            values?.mode != "planner" && (
              <AppExpander
                expanderStyle={{
                  zIndex: -1,
                }}
                style={{ minWidth: 250, zIndex: -1 }}
                title="Agent feedback"
                icon={AppAssets.icons.teach}
              >
                <View
                  style={{
                    paddingLeft: 10,
                    gap: 5,
                  }}
                >
                  {agentFeedbackList?.length > 0 ? (
                    agentFeedbackList?.map((u, i) => {
                      return (
                        <div
                          key={i}
                          style={{
                            paddingVertical: 10,
                            flexDirection: "column",
                            display: "flex",

                            border: `1px solid ${currentTheme?.theme?.primary_medium}`,
                            borderRadius: 10,
                            padding: 5,
                          }}
                        >
                          <AppText>
                            {u?.text?.length > 90
                              ? `Message: ${u?.text
                                  ?.trim()
                                  ?.replace(/\n+/g, " ")
                                  ?.replace(/\s+/g, " ")
                                  .slice(0, 90)}...`
                              : `Feedack: ${u?.text
                                  ?.trim()
                                  ?.replace(/\n+/g, " ")
                                  ?.replace(/\s+/g, " ")}`}
                          </AppText>
                          <AppText>{`Feedback: ${u?.humanFeedbackComment}`}</AppText>

                          <AppText
                            style={{
                              fontWeight: "bold",
                              // textDecoration: "underline",
                              textDecorationColor: currentTheme?.theme?.primary,
                              paddingTop: 10,
                            }}
                            clickableViewWrapperStyle={{
                              width: 80,
                            }}
                            color={currentTheme?.theme?.primary}
                            isClickable
                            onPress={() => {
                              history.push(
                                `/workspaces/${
                                  getActiveWorkspace()?.id
                                }/chats/${u?.chatID}`
                              );
                            }}
                          >{`Go to chat`}</AppText>
                        </div>
                      );
                    })
                  ) : (
                    <View
                      style={{
                        paddingLeft: 0,
                      }}
                    >
                      <AppPlaceholderView
                        wrapperStyle={{
                          width: "80%",
                          height: "100%",
                          marginVertical: "auto",
                          marginHorizontal: "auto",
                          alignItems: "center",
                        }}
                        size={30}
                        icon={AppAssets.icons.orbit}
                        mainCaption="Nothing to show here yet..."
                        subCaption="Start providing the agent feedback in a chat to see the first instruction appear here"
                      />
                    </View>
                  )}
                </View>
              </AppExpander>
            )}

          <View
            style={{
              zIndex: 10,
            }}
          >
            {isChatBot && values?.mode == "planner" && (
              <AppExpander
                expanderStyle={{
                  zIndex: 10000,
                }}
                style={{ minWidth: 250, zIndex: 20 }}
                title="Planner tools"
                icon={AppAssets.icons.agentsPlan}
              >
                <View
                  style={{
                    paddingLeft: 10,
                  }}
                >
                  <AppForms.AppFormMultiSelect
                    name="agentsPool"
                    topErrorOffset={-21}
                    touchedByDefault
                    placeholder="Available agents for planning"
                    hidePlaceholder={true}
                    items={_agents}
                    uniqueKey="id"
                    showDropDowns={true}
                    readOnlyHeadings={true}
                    labelOption="label"
                    groupByProperty="type"
                    style={{ maxWidth: 800 }}
                    wrapperContainerStyle={{
                      flex: !isLargeScreen() ? 1 : 0.5,
                      zIndex: 20,
                      paddingTop: 10,
                      marginBottom: 10,
                    }}
                    styles={colourStyles}
                    options={_agents.map((u) => {
                      return {
                        ...u,
                        value: u?.id,
                      };
                    })}
                  />

                  <AppForms.AppFormField
                    showTextInputLabel
                    wrapperInputStyle={{
                      paddingTop: 10,
                    }}
                    multiline={true}
                    textContainer={{
                      minHeight: 480,
                      paddingVertical: 10,
                    }}
                    label={`Planning instructions`}
                    placeholder={`planning_instructions_placeholder`}
                    keyboardtype="default"
                    textContextType="label"
                    autoCorrect={false}
                    name="planningInstructions"
                  />
                  <AppForms.AppFormSwitch
                    // disabled={isEdit}
                    // disabled={true}
                    wrapperStyle={[
                      {
                        backgroundColor: isEdit
                          ? currentTheme?.theme?.grey
                          : currentTheme?.theme?.lightGrey,
                        maxHeight: 30,
                        paddingHorizontal: 10,

                        paddingVertical: 18,
                        margin: 5,
                        marginBottom: 10,
                      },
                    ]}
                    labelTextStyle={{
                      fontSize: currentTheme?.theme?.small_font_size,
                      color: currentTheme?.theme?.darkGrey,
                    }}
                    showTextInputLabel={true}
                    label={"Deep thinking"}
                    displayIsTicked={true}
                    name="plannerDeepThinking"
                    value={values?.plannerDeepThinking}
                  />
                  <AppForms.AppFormField
                    showTextInputLabel
                    wrapperInputStyle={{
                      paddingTop: 10,
                    }}
                    multiline={true}
                    textContainer={{
                      minHeight: 240,
                      paddingVertical: 10,
                    }}
                    label={`Review instructions`}
                    placeholder={`review_instructions_placeholder`}
                    keyboardtype="default"
                    textContextType="label"
                    autoCorrect={false}
                    name="reviewInstructions"
                  />
                  <AppForms.AppFormSecureTextInput
                    containerWrapperStyle={{
                      marginLeft: 10,
                    }}
                    minimumValue={1}
                    maximumValue={10}
                    step={1}
                    label="Max execution steps"
                    inputType="SLIDER"
                    name="maxPlanningSteps"
                  />
                  <AppForms.AppFormSecureTextInput
                    containerWrapperStyle={{
                      marginLeft: 10,
                    }}
                    minimumValue={1}
                    maximumValue={5}
                    step={1}
                    label="Max re-attempts"
                    inputType="SLIDER"
                    name="plannerExecutionAttempts"
                  />
                  <AppForms.AppFormSwitch
                    // disabled={isEdit}
                    // disabled={true}
                    wrapperStyle={[
                      {
                        backgroundColor: isEdit
                          ? currentTheme?.theme?.grey
                          : currentTheme?.theme?.lightGrey,
                        maxHeight: 30,
                        paddingHorizontal: 10,

                        paddingVertical: 18,
                        margin: 5,
                        marginBottom: 10,
                      },
                    ]}
                    labelTextStyle={{
                      fontSize: currentTheme?.theme?.small_font_size,
                      color: currentTheme?.theme?.darkGrey,
                    }}
                    showTextInputLabel={true}
                    label={"Approval before execution"}
                    displayIsTicked={true}
                    name="plannerRequiresApprovalForPlanExecution"
                    value={values?.plannerRequiresApprovalForPlanExecution}
                  />
                  <AppForms.AppFormSwitch
                    // disabled={isEdit}
                    // disabled={true}
                    wrapperStyle={[
                      {
                        backgroundColor: isEdit
                          ? currentTheme?.theme?.grey
                          : currentTheme?.theme?.lightGrey,
                        maxHeight: 30,
                        paddingHorizontal: 10,

                        paddingVertical: 18,
                        margin: 5,
                        marginBottom: 10,
                      },
                    ]}
                    labelTextStyle={{
                      fontSize: currentTheme?.theme?.small_font_size,
                      color: currentTheme?.theme?.darkGrey,
                    }}
                    showTextInputLabel={true}
                    label={"Allow replanning during execution"}
                    displayIsTicked={true}
                    name="allowReplanning"
                    value={values?.allowReplanning}
                  />

                  <>
                    <AppForms.AppFormSwitch
                      // disabled={isEdit}
                      // disabled={true}
                      wrapperStyle={[
                        {
                          backgroundColor: isEdit
                            ? currentTheme?.theme?.grey
                            : currentTheme?.theme?.lightGrey,
                          maxHeight: 30,
                          paddingHorizontal: 10,

                          paddingVertical: 18,
                          margin: 5,
                          marginBottom: 10,
                        },
                      ]}
                      labelTextStyle={{
                        fontSize: currentTheme?.theme?.small_font_size,
                        color: currentTheme?.theme?.darkGrey,
                      }}
                      showTextInputLabel={true}
                      label={"Dynamic agents generation"}
                      displayIsTicked={true}
                      name="plannerAutoAgentSpawn"
                      value={values?.plannerAutoAgentSpawn}
                    />
                    {values?.plannerAutoAgentSpawn && (
                      <AppForms.AppFormMultiSelect
                        name="allowedTopics"
                        topErrorOffset={-21}
                        touchedByDefault
                        placeholder="Available topics for dynamically generated retriever agents"
                        hidePlaceholder={true}
                        items={_topics}
                        uniqueKey="id"
                        showDropDowns={true}
                        readOnlyHeadings={true}
                        labelOption="label"
                        groupByProperty="type"
                        style={{ maxWidth: 800 }}
                        wrapperContainerStyle={{
                          flex: !isLargeScreen() ? 1 : 0.5,
                          zIndex: 20,
                          paddingTop: 10,
                          marginBottom: 20,
                          marginHorizontal: 5,
                        }}
                        styles={colourStyles}
                        options={_topics.map((u) => {
                          return {
                            ...u,
                            value: u?.id,
                          };
                        })}
                      />
                    )}

                    {/* <AppForms.AppFormSwitch
                      // disabled={isEdit}
                      // disabled={true}
                      wrapperStyle={[
                        {
                          backgroundColor: isEdit
                            ? currentTheme?.theme?.grey
                            : currentTheme?.theme?.lightGrey,
                          maxHeight: 30,
                          paddingHorizontal: 10,
                           
                          paddingVertical: 18,
                          margin: 5,
                          marginBottom: 10,
                        },
                      ]}
                      labelTextStyle={{
                        fontSize: currentTheme?.theme?.small_font_size,
                        color: currentTheme?.theme?.darkGrey,
                      }}
                      showTextInputLabel={true}
                      label={"Retain spawned agents"}
                      displayIsTicked={true}
                      name="plannerRetainsSpawnedAgents"
                      value={values?.plannerRetainsSpawnedAgents}
                    /> */}
                  </>
                  <AppInputLabel
                    style={{ marginBottom: 10, marginLeft: 10, marginTop: 5 }}
                    labelTextStyle={{
                      fontSize: currentTheme?.theme?.small_font_size,
                    }}
                    label={"Notifications"}
                  />
                  <AppForms.AppFormSwitch
                    // disabled={isEdit}
                    // disabled={true}
                    wrapperStyle={[
                      {
                        backgroundColor: isEdit
                          ? currentTheme?.theme?.grey
                          : currentTheme?.theme?.lightGrey,
                        maxHeight: 30,
                        paddingHorizontal: 10,

                        paddingVertical: 18,
                        margin: 5,
                        marginBottom: 10,
                      },
                    ]}
                    labelTextStyle={{
                      fontSize: currentTheme?.theme?.small_font_size,
                      color: currentTheme?.theme?.darkGrey,
                    }}
                    showTextInputLabel={true}
                    label={"Email to notify plan approval request"}
                    displayIsTicked={true}
                    name="plannerEmailOnApprovalRequest"
                    value={values?.plannerEmailOnApprovalRequest}
                  />
                  <AppForms.AppFormSwitch
                    // disabled={isEdit}
                    // disabled={true}
                    wrapperStyle={[
                      {
                        backgroundColor: isEdit
                          ? currentTheme?.theme?.grey
                          : currentTheme?.theme?.lightGrey,
                        maxHeight: 30,
                        paddingHorizontal: 10,

                        paddingVertical: 18,
                        margin: 5,
                        marginBottom: 10,
                      },
                    ]}
                    labelTextStyle={{
                      fontSize: currentTheme?.theme?.small_font_size,
                      color: currentTheme?.theme?.darkGrey,
                    }}
                    showTextInputLabel={true}
                    label={"Email to notify plan failure"}
                    displayIsTicked={true}
                    name="plannerEmailOnFailedPlan"
                    value={values?.plannerEmailOnFailedPlan}
                  />
                  <AppForms.AppFormSwitch
                    // disabled={isEdit}
                    // disabled={true}
                    wrapperStyle={[
                      {
                        backgroundColor: isEdit
                          ? currentTheme?.theme?.grey
                          : currentTheme?.theme?.lightGrey,
                        maxHeight: 30,
                        paddingHorizontal: 10,

                        paddingVertical: 18,
                        margin: 5,
                        marginBottom: 10,
                      },
                    ]}
                    labelTextStyle={{
                      fontSize: currentTheme?.theme?.small_font_size,
                      color: currentTheme?.theme?.darkGrey,
                    }}
                    showTextInputLabel={true}
                    label={"Email to notify plan completion"}
                    displayIsTicked={true}
                    name="plannerEmailOnCompletedPlan"
                    value={values?.plannerEmailOnCompletedPlan}
                  />
                  <AppInputLabel
                    style={{ marginBottom: 0, marginLeft: 10 }}
                    labelTextStyle={{
                      fontSize: currentTheme?.theme?.small_font_size,
                    }}
                    label={"Recipients"}
                  />
                  <AppForms.AppFormMultiSelect
                    name="plannerApproverEmails"
                    topErrorOffset={-21}
                    touchedByDefault
                    placeholder="Set static notification recipients"
                    hidePlaceholder={true}
                    items={getWorkspaceUsers()}
                    uniqueKey="id"
                    showDropDowns={true}
                    readOnlyHeadings={true}
                    style={{ maxWidth: 800 }}
                    wrapperContainerStyle={{
                      flex: !isLargeScreen() ? 1 : 0.5,
                      zIndex: 20,
                      paddingTop: 10,
                      marginBottom: 40,
                      marginHorizontal: 5,
                    }}
                    styles={colourStyles}
                    options={getWorkspaceUsers()?.map((u) => {
                      return {
                        ...u,
                        value: u?.id,
                        label: u?.username || u?.user_email,
                        category: "user",
                        backgroundColor: AppUtilities.stringToHslColor(
                          u?.username || u?.user_email,
                          71
                        ),
                      };
                    })}
                  />
                </View>
              </AppExpander>
            )}
          </View>
          {isChatBot &&
            !["coder", "computer"].includes(values?.mode) &&
            !isAgentOllama && (
              <AppExpander
                style={{ minWidth: 250, zIndex: -1 }}
                title="Agent tools"
                icon={AppAssets.icons.advanced}
              >
                {values?.mode != "planner" && (
                  <View
                    style={{
                      paddingLeft: 10,
                    }}
                  >
                    <View>
                      <AppForms.AppFormSwitch
                        // disabled={isEdit}
                        // disabled={true}
                        wrapperStyle={[
                          {
                            backgroundColor: isEdit
                              ? currentTheme?.theme?.grey
                              : currentTheme?.theme?.lightGrey,
                            maxHeight: 30,
                            paddingHorizontal: 10,

                            paddingVertical: 18,
                            margin: 5,
                          },
                        ]}
                        labelTextStyle={{
                          fontSize: currentTheme?.theme?.small_font_size,
                          color: currentTheme?.theme?.darkGrey,
                        }}
                        showTextInputLabel={true}
                        label={"Summarised memory in chats"}
                        displayIsTicked={true}
                        name="summarisation"
                        value={values?.summarisation}
                      />
                    </View>
                  </View>
                )}
                <View
                  style={{
                    paddingLeft: 10,
                  }}
                >
                  <AppForms.AppFormSwitch
                    // disabled={isEdit}
                    // disabled={values?.summarisation == false}
                    wrapperStyle={[
                      {
                        backgroundColor: isEdit
                          ? currentTheme?.theme?.grey
                          : currentTheme?.theme?.lightGrey,
                        maxHeight: 30,
                        paddingHorizontal: 10,

                        paddingVertical: 18,
                        margin: 5,
                        marginTop: 20,
                      },
                    ]}
                    labelTextStyle={{
                      fontSize: currentTheme?.theme?.small_font_size,
                      color: currentTheme?.theme?.darkGrey,
                    }}
                    showTextInputLabel={true}
                    label={"Long term memory"}
                    displayIsTicked={true}
                    name="isLongTermMemoryEnabled"
                    value={values?.isLongTermMemoryEnabled}
                  />
                  <AppText
                    style={{
                      paddingLeft: 10,

                      fontSize: currentTheme?.theme?.extra_small_font_size,
                    }}
                    wrapperStyle={{
                      top: 0,
                      marginLeft: 15,
                      justifyContent: "center",
                    }}
                    iconSize={12}
                    leftIcon={AppAssets?.icons?.question_icon}
                  >
                    {values?.mode == "planner"
                      ? "Long term memory generated based on the plans executed to improve planning and execution skills longer term. It improves the agent behaviour overtime."
                      : "Long term memory is retained across chats with the agent and is built when the user asks the agent to remember something. It improves the agent behaviour overtime"}
                  </AppText>
                  <AppText
                    leftIcon={AppAssets?.icons?.delete}
                    style={{
                      paddingLeft: 5,
                      fontSize: currentTheme?.theme?.extra_small_font_size,
                      textDecorationColor: currentTheme?.theme?.red,
                    }}
                    isClickable
                    color={currentTheme?.theme?.red}
                    onPress={clearMemory}
                    wrapperStyle={{
                      alignSelf: "flex-end",
                    }}
                    iconSize={12}
                  >
                    Clear memory
                  </AppText>
                </View>

                {isChatBot && values?.mode != "coder" && (
                  <>
                    <View
                      style={{
                        paddingLeft: 10,
                      }}
                    >
                      <AppForms.AppFormSwitch
                        wrapperStyle={[
                          {
                            backgroundColor: isEdit
                              ? currentTheme?.theme?.grey
                              : currentTheme?.theme?.lightGrey,
                            maxHeight: 30,
                            paddingHorizontal: 10,

                            paddingVertical: 18,
                            margin: 5,
                            marginTop: 20,
                          },
                        ]}
                        labelTextStyle={{
                          fontSize: currentTheme?.theme?.small_font_size,
                          color: currentTheme?.theme?.darkGrey,
                        }}
                        showTextInputLabel={true}
                        label={"Charts generation"}
                        displayIsTicked={true}
                        name="charting"
                        value={values?.charting}
                        disabled={disableMultiModal || disableDueToTranslation}
                      />
                      {(disableMultiModal || disableDueToTranslation) && (
                        <AppText
                          style={{
                            paddingLeft: 10,

                            fontSize:
                              currentTheme?.theme?.extra_small_font_size,
                          }}
                          wrapperStyle={{
                            top: 0,
                            marginLeft: 10,
                            justifyContent: "center",
                          }}
                          iconSize={12}
                          leftIcon={AppAssets?.icons?.question_icon}
                        >
                          Charts generation is disabled due to multilingual mode
                          or the LLM selected is not of type sorcerer/mystica
                        </AppText>
                      )}
                      {["chatter", "planner"]?.includes(values?.mode) && (
                        <AppForms.AppFormSwitch
                          wrapperStyle={[
                            {
                              backgroundColor: isEdit
                                ? currentTheme?.theme?.grey
                                : currentTheme?.theme?.lightGrey,
                              maxHeight: 30,
                              paddingHorizontal: 10,

                              paddingVertical: 18,
                              margin: 5,
                              marginTop: 20,
                            },
                          ]}
                          labelTextStyle={{
                            fontSize: currentTheme?.theme?.small_font_size,
                            color: currentTheme?.theme?.darkGrey,
                          }}
                          showTextInputLabel={true}
                          label={"Enable docs upload"}
                          displayIsTicked={true}
                          name="allowDocsUpload"
                          value={values?.allowDocsUpload}
                          disabled={values?.mode == "retriever"}
                        />
                      )}

                      <AppForms.AppFormSwitch
                        wrapperStyle={[
                          {
                            backgroundColor: isEdit
                              ? currentTheme?.theme?.grey
                              : currentTheme?.theme?.lightGrey,
                            maxHeight: 30,
                            paddingHorizontal: 10,

                            paddingVertical: 18,
                            margin: 5,
                            marginTop: 20,
                          },
                        ]}
                        labelTextStyle={{
                          fontSize: currentTheme?.theme?.small_font_size,
                          color: currentTheme?.theme?.darkGrey,
                        }}
                        showTextInputLabel={true}
                        label={"Enable images upload"}
                        displayIsTicked={true}
                        name="allowImagesUpload"
                        value={values?.allowImagesUpload}
                      />
                      <AppForms.AppFormSwitch
                        wrapperStyle={[
                          {
                            backgroundColor: isEdit
                              ? currentTheme?.theme?.grey
                              : currentTheme?.theme?.lightGrey,
                            maxHeight: 30,
                            paddingHorizontal: 10,

                            paddingVertical: 18,
                            margin: 5,
                            marginTop: 20,
                          },
                        ]}
                        labelTextStyle={{
                          fontSize: currentTheme?.theme?.small_font_size,
                          color: currentTheme?.theme?.darkGrey,
                        }}
                        showTextInputLabel={true}
                        label={"Enable audio upload"}
                        displayIsTicked={true}
                        name="allowAudiosUpload"
                        value={values?.allowAudiosUpload}
                      />
                      <AppForms.AppFormSwitch
                        wrapperStyle={[
                          {
                            backgroundColor: isEdit
                              ? currentTheme?.theme?.grey
                              : currentTheme?.theme?.lightGrey,
                            maxHeight: 30,
                            paddingHorizontal: 10,

                            paddingVertical: 18,
                            margin: 5,
                            marginTop: 20,
                          },
                        ]}
                        labelTextStyle={{
                          fontSize: currentTheme?.theme?.small_font_size,
                          color: currentTheme?.theme?.darkGrey,
                        }}
                        showTextInputLabel={true}
                        label={"Enable video upload"}
                        displayIsTicked={true}
                        name="allowVideosUpload"
                        value={values?.allowVideosUpload}
                      />
                      <>
                        <AppForms.AppFormSwitch
                          wrapperStyle={[
                            {
                              backgroundColor: isEdit
                                ? currentTheme?.theme?.grey
                                : currentTheme?.theme?.lightGrey,
                              maxHeight: 30,
                              paddingHorizontal: 10,

                              paddingVertical: 18,
                              margin: 5,
                              marginTop: 20,
                            },
                          ]}
                          labelTextStyle={{
                            fontSize: currentTheme?.theme?.small_font_size,
                            color: currentTheme?.theme?.darkGrey,
                          }}
                          showTextInputLabel={true}
                          label={"Enable audio generation"}
                          displayIsTicked={true}
                          name="allowAudiosGeneration"
                          value={values?.allowAudiosGeneration}
                          disabled={
                            getActiveWorkspace()?.subscriptionType == "base"
                          }
                        />

                        <AppForms.AppFormSwitch
                          wrapperStyle={[
                            {
                              backgroundColor: isEdit
                                ? currentTheme?.theme?.grey
                                : currentTheme?.theme?.lightGrey,
                              maxHeight: 30,
                              paddingHorizontal: 10,

                              paddingVertical: 18,
                              margin: 5,
                              marginTop: 20,
                            },
                          ]}
                          labelTextStyle={{
                            fontSize: currentTheme?.theme?.small_font_size,
                            color: currentTheme?.theme?.darkGrey,
                          }}
                          showTextInputLabel={true}
                          label={`Enable speech to speech${
                            getActiveWorkspace()?.subscriptionType !=
                            "enterprise"
                              ? " - Enterprise only"
                              : ""
                          } `}
                          displayIsTicked={true}
                          name="autoVoiceMode"
                          value={values?.autoVoiceMode}
                          disabled={
                            !values?.allowAudiosGeneration ||
                            getActiveWorkspace()?.subscriptionType !=
                              "enterprise"
                          }
                        />
                        {getActiveWorkspace()?.subscriptionType != "base" && (
                          <View>
                            <AudioPlaceholder
                              audioPath={values?.voiceFileKey}
                              onFileSelection={(file) =>
                                handleAudioSelection(file)
                              }
                              isFileUploadInProgress={fileUploadInProgress}
                              fileUploadProgress={fileUploadProgress}
                              isVoiceRecordingInProgress={isAudioRecording}
                            >
                              <AudioRecorder
                                onRecordingCompleted={handleRecordingCompleted}
                                onRecordingStarted={handleRecordingStarted}
                                style={{
                                  justifyContent: "flex-start",
                                  marginTop: 0,
                                  marginLeft: 10,
                                }}
                                onForcedStop={() => {
                                  setIsAudioRecording(false);
                                }}
                              />
                            </AudioPlaceholder>
                          </View>
                        )}
                      </>
                    </View>
                    {isKnowledgeEnabled && values?.mode != "coder" && (
                      <View
                        style={{
                          paddingLeft: 10,
                        }}
                      >
                        <AppForms.AppFormSwitch
                          wrapperStyle={[
                            {
                              backgroundColor: isEdit
                                ? currentTheme?.theme?.grey
                                : currentTheme?.theme?.lightGrey,
                              maxHeight: 30,
                              paddingHorizontal: 10,

                              paddingVertical: 18,
                              margin: 5,
                              marginTop: 20,
                            },
                          ]}
                          labelTextStyle={{
                            fontSize: currentTheme?.theme?.small_font_size,
                            color: currentTheme?.theme?.darkGrey,
                          }}
                          showTextInputLabel={true}
                          label={"Enhance answers with NER"}
                          displayIsTicked={true}
                          name="hasNER"
                          value={values?.hasNER}
                        />
                        <AppForms.AppFormSwitch
                          wrapperStyle={[
                            {
                              backgroundColor: isEdit
                                ? currentTheme?.theme?.grey
                                : currentTheme?.theme?.lightGrey,
                              maxHeight: 30,
                              paddingHorizontal: 10,

                              paddingVertical: 18,
                              margin: 5,
                              marginTop: 20,
                            },
                          ]}
                          labelTextStyle={{
                            fontSize: currentTheme?.theme?.small_font_size,
                            color: currentTheme?.theme?.darkGrey,
                          }}
                          showTextInputLabel={true}
                          label={"Images retrieval from knowledge hub"}
                          displayIsTicked={true}
                          name="hasImages"
                          value={values?.hasImages}
                          disabled={disableMultiModal}
                        />
                        {disableMultiModal && (
                          <AppText
                            style={{
                              paddingLeft: 10,

                              fontSize:
                                currentTheme?.theme?.extra_small_font_size,
                            }}
                            wrapperStyle={{
                              top: 0,
                              marginLeft: 10,
                            }}
                            iconSize={12}
                            leftIcon={AppAssets?.icons?.question_icon}
                          >
                            Images retrieval is disabled as the LLM selected is
                            not of type sorcerer/mystica
                          </AppText>
                        )}
                      </View>
                    )}
                  </>
                )}
                {values?.mode == "planner" && (
                  <AppText
                    style={{
                      paddingLeft: 5,
                      fontWeight: "bold",
                      fontSize: currentTheme?.theme?.extra_small_font_size,
                    }}
                    wrapperStyle={{
                      paddingVertical: 5,
                      top: 10,
                      justifyContent: "center",
                    }}
                    iconSize={12}
                    iconColor={currentTheme?.theme?.orange}
                    leftIcon={AppAssets?.icons?.warning}
                    color={currentTheme?.theme?.orange}
                  >
                    Planners must have access to agents with the necessary tools
                    to perform tasks that involve files
                  </AppText>
                )}
              </AppExpander>
            )}
          {isChatBot &&
            values?.mode == "chatter" &&
            !isAgentOllama &&
            getActiveWorkspace()?.subscriptionType != "base" && (
              <AppExpander
                style={{ minWidth: 250, zIndex: -1 }}
                title="Images generation"
                icon={AppAssets.icons.images}
              >
                <AppForms.AppFormSwitch
                  wrapperStyle={[
                    {
                      backgroundColor: isEdit
                        ? currentTheme?.theme?.grey
                        : currentTheme?.theme?.lightGrey,
                      maxHeight: 30,
                      paddingHorizontal: 10,

                      paddingVertical: 18,
                      marginHorizontal: 5,
                      marginVertical: 20,
                    },
                  ]}
                  labelTextStyle={{
                    fontSize: currentTheme?.theme?.small_font_size,
                    color: currentTheme?.theme?.darkGrey,
                  }}
                  showTextInputLabel={true}
                  label={"Allow images generation"}
                  displayIsTicked={true}
                  name="allowImagesGeneration"
                  value={values?.allowImagesGeneration}
                />
                <View
                  style={{
                    marginLeft: 0,
                    paddingLeft: 0,
                  }}
                >
                  <AppForms.AppFormDropDown
                    isElevated={false}
                    dropDownStyle={{
                      borderColor: currentTheme?.theme?.border_color,
                      maxWidth: !isLargeScreen() && 250,
                    }}
                    showTextInputLabel
                    label="Image generation model"
                    isMandatory
                    name="baseImageGenerationModel"
                    items={baseImageModels}
                    propertyLabel="name"
                    propertyValue="id"
                  />
                  <View
                    style={{
                      marginLeft: 20,
                      marginTop: 10,
                    }}
                  >
                    <AppForms.AppFormSlider
                      step={1}
                      maximumValue={
                        values?.baseImageGenerationModel ==
                          "black-forest-labs/flux-pro" ||
                        values?.baseImageGenerationModel ==
                          "black-forest-labs/flux-1.1-pro" ||
                        values?.baseImageGenerationModel ==
                          "black-forest-labs/flux-1.1-pro-ultra"
                          ? 1
                          : 4
                      }
                      minimumValue={1}
                      label="Max images generated"
                      name="maxImagesGenerated"
                      showEditButtons={true}
                    />
                  </View>
                </View>
              </AppExpander>
            )}
          {isChatBot &&
            values?.mode == "chatter" &&
            !isAgentOllama &&
            getActiveWorkspace()?.subscriptionType == "enterprise" && (
              <AppExpander
                style={{ minWidth: 250, zIndex: -1 }}
                title="Videos & 3D models generation"
                icon={AppAssets.icons.video}
              >
                <AppForms.AppFormSwitch
                  wrapperStyle={[
                    {
                      backgroundColor: isEdit
                        ? currentTheme?.theme?.grey
                        : currentTheme?.theme?.lightGrey,
                      maxHeight: 30,
                      paddingHorizontal: 10,

                      paddingVertical: 18,
                      marginHorizontal: 5,
                      marginVertical: 20,
                    },
                  ]}
                  labelTextStyle={{
                    fontSize: currentTheme?.theme?.small_font_size,
                    color: currentTheme?.theme?.darkGrey,
                  }}
                  showTextInputLabel={true}
                  label={"Allow videos generation"}
                  displayIsTicked={true}
                  name="allowVideosGeneration"
                  value={values?.allowVideosGeneration}
                />
                <View
                  style={{
                    marginLeft: 0,
                    paddingLeft: 0,
                  }}
                >
                  <AppForms.AppFormDropDown
                    isElevated={false}
                    dropDownStyle={{
                      borderColor: currentTheme?.theme?.border_color,
                      maxWidth: !isLargeScreen() && 250,
                    }}
                    showTextInputLabel
                    label="Video generation model"
                    isMandatory
                    name="videoGenerationModel"
                    items={[
                      {
                        name: "Mystica video SD",
                        id: "mystica_video_sd",
                      },
                      {
                        name: "Wan 2.1 3B",
                        id: "wan-video/wan-2.1-1.3b",
                      },
                      {
                        name: "Hunyuan video",
                        id: "tencent/hunyuan-video",
                      },
                    ]}
                    propertyLabel="name"
                    propertyValue="id"
                  />
                </View>
                <AppForms.AppFormSwitch
                  wrapperStyle={[
                    {
                      backgroundColor: isEdit
                        ? currentTheme?.theme?.grey
                        : currentTheme?.theme?.lightGrey,
                      maxHeight: 30,
                      paddingHorizontal: 10,

                      paddingVertical: 18,
                      marginHorizontal: 5,
                      marginVertical: 20,
                    },
                  ]}
                  labelTextStyle={{
                    fontSize: currentTheme?.theme?.small_font_size,
                    color: currentTheme?.theme?.darkGrey,
                  }}
                  showTextInputLabel={true}
                  label={"Allow 3D models generation"}
                  displayIsTicked={true}
                  name="allow3dModelGeneration"
                  value={values?.allow3dModelGeneration}
                />
              </AppExpander>
            )}
          {isChatBot && !["planner", "computer"].includes(values?.mode) && (
            <AppExpander
              style={{ minWidth: 250, zIndex: 1 }}
              isExpandedOnLoad={false}
              title="Multilingual"
              icon={AppAssets.icons.language}
            >
              <View
                style={{
                  paddingLeft: 10,
                }}
              >
                <AppForms.AppFormSwitch
                  // disabled={isEdit}
                  wrapperStyle={[
                    {
                      backgroundColor: isEdit
                        ? currentTheme?.theme?.grey
                        : currentTheme?.theme?.lightGrey,
                      maxHeight: 30,
                      paddingHorizontal: 10,

                      paddingVertical: 18,
                      margin: 5,
                      marginTop: 20,
                    },
                  ]}
                  labelTextStyle={{
                    fontSize: currentTheme?.theme?.small_font_size,
                    color: currentTheme?.theme?.darkGrey,
                  }}
                  showTextInputLabel={true}
                  label={"Multilingual"}
                  displayIsTicked={true}
                  name="isMultiLanguageEnabled"
                  value={values?.isMultiLanguageEnabled !== false}
                  disabled={
                    getActiveWorkspace()?.subscriptionType != "enterprise"
                  }
                />
                {getActiveWorkspace()?.subscriptionType != "enterprise" && (
                  <AppText
                    leftIcon={AppAssets?.icons?.info}
                    wrapperStyle={{
                      paddingHorizontal: 10,
                    }}
                    color={currentTheme?.theme?.orange}
                    style={{
                      marginLeft: 10,
                    }}
                    iconSize={14}
                  >
                    Global languages support is available only for the
                    enterprise subscriptions
                  </AppText>
                )}
                {values?.isMultiLanguageEnabled && (
                  <AppText
                    leftIcon={AppAssets?.icons?.info}
                    wrapperStyle={{
                      paddingHorizontal: 10,
                    }}
                    color={currentTheme?.theme?.orange}
                    style={{
                      marginLeft: 10,
                    }}
                    iconSize={14}
                  >
                    Your agent will not be able to generate charts while the
                    multilingual option is enabled.
                  </AppText>
                )}

                <AppForms.AppFormSwitch
                  wrapperStyle={[
                    {
                      backgroundColor: isEdit
                        ? currentTheme?.theme?.grey
                        : currentTheme?.theme?.lightGrey,
                      maxHeight: 30,
                      paddingHorizontal: 10,

                      paddingVertical: 18,
                      margin: 5,
                      marginTop: 20,
                    },
                  ]}
                  labelTextStyle={{
                    fontSize: currentTheme?.theme?.small_font_size,
                    color: currentTheme?.theme?.darkGrey,
                  }}
                  showTextInputLabel={true}
                  label={"Dynamic language detection"}
                  displayIsTicked={true}
                  name="advancedLanguageDetection"
                  value={values?.advancedLanguageDetection}
                  disabled={!values?.isMultiLanguageEnabled}
                />
                <AppForms.AppFormSwitch
                  wrapperStyle={[
                    {
                      backgroundColor: isEdit
                        ? currentTheme?.theme?.grey
                        : currentTheme?.theme?.lightGrey,
                      maxHeight: 30,
                      paddingHorizontal: 10,

                      paddingVertical: 18,
                      margin: 5,
                      marginTop: 20,
                    },
                  ]}
                  labelTextStyle={{
                    fontSize: currentTheme?.theme?.small_font_size,
                    color: currentTheme?.theme?.darkGrey,
                  }}
                  showTextInputLabel={true}
                  label={"Show detected language"}
                  displayIsTicked={true}
                  name="showDetectedLanguage"
                  value={values?.showDetectedLanguage}
                  disabled={!values?.isMultiLanguageEnabled}
                />
                <View
                  style={{
                    marginLeft: 10,
                    marginTop: 10,
                  }}
                >
                  <AppForms.AppFormSlider
                    step={0.01}
                    maximumValue={1}
                    minimumValue={0.5}
                    label="Min. confidence"
                    name="languageDetectionConfidence"
                    showEditButtons={values?.isMultiLanguageEnabled}
                  />
                </View>
              </View>
            </AppExpander>
          )}
          {isChatBot &&
            values?.restrictedAccess != true &&
            !["planner", "computer"].includes(values?.mode) && (
              <AppExpander
                style={{ minWidth: 250, zIndex: 1 }}
                isExpandedOnLoad={false}
                title="Appearance and Web Widget"
                icon={AppAssets.icons.widget}
              >
                <AppText
                  style={{
                    paddingLeft: 30,
                    paddingBottom: 5,
                  }}
                  fontWeight="bold"
                >
                  Splash Logo
                </AppText>
                <ImagePlaceholder
                  onFileSelection={(file) => handleIconSelection(file, true)}
                  imagePath={agentLogo}
                  isFileUploadInProgress={fileUploadInProgress}
                  fileUploadProgress={fileUploadProgress}
                  isLargeLogo
                  style={{
                    alignSelf: "flex-start",
                    marginLeft: 10,
                    paddingLeft: 0,
                  }}
                />

                {/* largeLogo */}
                <View
                  style={{
                    paddingLeft: 10,
                    zIndex: 20,
                  }}
                >
                  <AppForms.AppFormField
                    showTextInputLabel
                    wrapperInputStyle={{
                      paddingTop: 10,
                    }}
                    multiline={true}
                    textContainer={{
                      minHeight: 120,
                      paddingVertical: 10,
                    }}
                    label={`First message`}
                    placeholder={`message_launch_text_placeholder`}
                    keyboardtype="default"
                    textContextType="label"
                    autoCorrect={false}
                    name="messageOnLaunch"
                  />
                  <AppForms.AppFormSwitch
                    wrapperStyle={[
                      {
                        backgroundColor: isEdit
                          ? currentTheme?.theme?.grey
                          : currentTheme?.theme?.lightGrey,
                        maxHeight: 30,
                        paddingHorizontal: 10,

                        paddingVertical: 18,
                        marginHorizontal: 5,
                        marginVertical: 20,
                      },
                    ]}
                    labelTextStyle={{
                      fontSize: currentTheme?.theme?.small_font_size,
                      color: currentTheme?.theme?.darkGrey,
                    }}
                    showTextInputLabel={true}
                    label={"Show splash message"}
                    displayIsTicked={true}
                    name="showSplashWhenEmpty"
                    value={values?.showSplashWhenEmpty}
                  />
                  <AppForms.AppFormSwitch
                    wrapperStyle={[
                      {
                        backgroundColor: isEdit
                          ? currentTheme?.theme?.grey
                          : currentTheme?.theme?.lightGrey,
                        maxHeight: 30,
                        paddingHorizontal: 10,

                        paddingVertical: 18,
                        marginHorizontal: 5,
                        marginVertical: 20,
                      },
                    ]}
                    labelTextStyle={{
                      fontSize: currentTheme?.theme?.small_font_size,
                      color: currentTheme?.theme?.darkGrey,
                    }}
                    showTextInputLabel={true}
                    label={"Show agent name"}
                    displayIsTicked={true}
                    name="showAgentName"
                    value={values?.showAgentName}
                  />

                  <AppForms.AppFormField
                    showTextInputLabel
                    wrapperInputStyle={{
                      paddingTop: 10,
                      marginLeft: -5,
                    }}
                    multiline={false}
                    // textContainer={{
                    //   minHeight: 120,
                    //   paddingVertical: 10,
                    // }}
                    label={`Input placeholder`}
                    placeholder={`input_text_placeholder`}
                    keyboardtype="default"
                    textContextType="label"
                    autoCorrect={false}
                    name="placeholderInputMessage"
                  />
                  <AppForms.AppFormField
                    showTextInputLabel
                    wrapperInputStyle={{
                      paddingTop: 10,
                    }}
                    multiline={true}
                    textContainer={{
                      paddingVertical: 10,
                    }}
                    label={`Loading placeholder`}
                    placeholder={`loading_text_placeholder`}
                    keyboardtype="default"
                    textContextType="label"
                    autoCorrect={false}
                    name="placeholderMessageOnLoading"
                  />

                  <AppForms.AppFormField
                    showTextInputLabel
                    wrapperInputStyle={{
                      paddingTop: 10,
                    }}
                    multiline={true}
                    textContainer={{
                      minHeight: 120,
                      paddingVertical: 10,
                    }}
                    label={`Disclaimer`}
                    placeholder={`disclaimer_placeholder`}
                    keyboardtype="default"
                    textContextType="label"
                    autoCorrect={false}
                    name="disclaimer"
                  />
                  <AppForms.AppFormField
                    showTextInputLabel
                    wrapperInputStyle={{
                      paddingTop: 10,
                      paddingBottom: 10,
                    }}
                    textContainer={{
                      paddingVertical: 10,
                    }}
                    errorOffset={-13}
                    label={`Icons color in light mode`}
                    placeholder={`Hex color (e.g. #5d94d6)`}
                    keyboardtype="default"
                    textContextType="label"
                    autoCorrect={false}
                    name="color"
                  />
                  <AppForms.AppFormField
                    showTextInputLabel
                    wrapperInputStyle={{
                      paddingTop: 10,
                      paddingBottom: 10,
                    }}
                    textContainer={{
                      paddingVertical: 10,
                    }}
                    errorOffset={-13}
                    label={`Icons color in dark mode`}
                    placeholder={`Hex color (e.g. #5d94d6)`}
                    keyboardtype="default"
                    textContextType="label"
                    autoCorrect={false}
                    name="darkColor"
                  />
                  <AppForms.AppFormField
                    showTextInputLabel
                    wrapperInputStyle={{
                      paddingTop: 10,
                      paddingBottom: 10,
                    }}
                    textContainer={{
                      paddingVertical: 10,
                    }}
                    errorOffset={-13}
                    label={`Splash background in light mode`}
                    placeholder={`Hex color (e.g. #5d94d6)`}
                    keyboardtype="default"
                    textContextType="label"
                    autoCorrect={false}
                    name="logoBackground"
                  />
                  <AppForms.AppFormField
                    showTextInputLabel
                    wrapperInputStyle={{
                      paddingTop: 10,
                      paddingBottom: 10,
                    }}
                    textContainer={{
                      paddingVertical: 10,
                    }}
                    errorOffset={-13}
                    label={`Splash background in dark mode`}
                    placeholder={`Hex color (e.g. #5d94d6)`}
                    keyboardtype="default"
                    textContextType="label"
                    autoCorrect={false}
                    name="darkLogoBackground"
                  />
                  <AppForms.AppFormDropDown
                    isElevated={false}
                    dropDownStyle={{
                      borderColor: currentTheme?.theme?.border_color,
                      maxWidth: !isLargeScreen() && 250,
                    }}
                    showTextInputLabel
                    label="Theme control"
                    isMandatory
                    name="forcedTheme"
                    items={[
                      { id: "auto", name: "Auto" },
                      { id: "light", name: "Light" },
                      { id: "dark", name: "Dark" },
                    ]}
                    propertyLabel="name"
                    propertyValue="id"
                  />

                  <AppForms.AppFormField
                    showTextInputLabel
                    wrapperInputStyle={{
                      paddingTop: 10,
                    }}
                    multiline={true}
                    textContainer={{
                      minHeight: 120,
                      paddingVertical: 10,
                    }}
                    errorOffset={0}
                    label={`Initial questions`}
                    placeholder={`Insert up top 3 initial questions seperated by a semicolon`}
                    keyboardtype="default"
                    textContextType="label"
                    autoCorrect={false}
                    name="quickQuestions"
                  />

                  {isEdit &&
                    getActiveWorkspace()?.subscriptionType != "base" &&
                    !isAgentOllama && (
                      <AppText
                        wrapperStyle={{
                          alignSelf: "flex-start",
                          marginBottom: 10,
                          width: "100%",
                          marginTop: 10,
                        }}
                        leftIcon={AppAssets?.icons?.link}
                        leftIconStyle={{
                          marginLeft: 20,
                        }}
                        style={{
                          color: currentTheme?.theme?.primary,
                          left: 55,
                          fontWeight: "bold",
                          position: "absolute",
                        }}
                        rightIcon={AppAssets?.icons?.quickCopy}
                        isClickable
                        onPress={() => {
                          // open in new tab
                          window.open(agentLink, "_blank");
                        }}
                        onRightIconPress={() => {
                          AppToasty.show("Copied to clipboard", {
                            type: "success",
                          });
                          navigator.clipboard.writeText(agentLink);
                        }}
                        textStyle={{
                          marginLeft: 0,
                        }}
                        width={420}
                      >
                        Go to widget
                      </AppText>
                    )}
                  {!isAgentOllama && (
                    <View>
                      <AppForms.AppFormSwitch
                        wrapperStyle={[
                          {
                            backgroundColor: isEdit
                              ? currentTheme?.theme?.grey
                              : currentTheme?.theme?.lightGrey,
                            maxHeight: 30,
                            paddingHorizontal: 10,

                            paddingVertical: 18,
                            marginHorizontal: 5,
                            marginVertical: 20,
                          },
                        ]}
                        labelTextStyle={{
                          fontSize: currentTheme?.theme?.small_font_size,
                          color: currentTheme?.theme?.darkGrey,
                        }}
                        showTextInputLabel={true}
                        label={"Block external usage"}
                        displayIsTicked={true}
                        name="preventWidgetUsage"
                        value={values?.preventWidgetUsage}
                        disabled={
                          getActiveWorkspace()?.subscriptionType == "base"
                        }
                      />
                    </View>
                  )}

                  {getActiveWorkspace()?.subscriptionType != "base" &&
                    !isAgentOllama && (
                      <View
                        style={{
                          flexDirection: "row",
                          justifyContent: "space-between",
                          alignItems: "flex-start",
                          marginLeft: 20,
                        }}
                      >
                        <View
                          style={{
                            flexDirection: "column",
                          }}
                        >
                          <AppText
                            wrapperStyle={{
                              paddingBottom: 10,
                            }}
                            fontWeight="bold"
                            style={{
                              fontSize: 16,
                            }}
                          >
                            Add this agent to your website
                          </AppText>
                          <AppText
                            wrapperStyle={{
                              paddingBottom: 10,
                            }}
                            style={{
                              fontSize: 14,
                            }}
                            iconSize={16}
                            rightIcon={
                              codeExpanded
                                ? AppAssets?.icons?.collapse
                                : AppAssets?.icons?.expand
                            }
                            isClickable
                            onRightIconPress={() => {
                              setCodeExpanded(!codeExpanded);
                            }}
                          >
                            Copy and paste this code into your website HTML
                          </AppText>
                        </View>
                        <AppIcon
                          icon={AppAssets?.icons?.quickCopy}
                          isClickable
                          onPress={async () => {
                            try {
                              AppToasty.show("HTML copied to clipboard", {
                                type: "success",
                              });
                              await navigator.clipboard.writeText(widgetString);
                            } catch (error) {
                              AppToasty.show("Error copying to clipboard", {
                                type: "danger",
                              });
                            }
                          }}
                        />
                      </View>
                    )}

                  {codeExpanded && (
                    <pre
                      style={{
                        padding: 16,
                        border: `1px solid ${currentTheme?.theme?.color}`,

                        backgroundColor:
                          currentTheme?.theme?.inputBackgroundColor,
                        overflow: "auto",
                        maxHeight: 300,
                      }}
                    >
                      <code
                        style={{
                          fontFamily: "monospace",
                          fontSize: currentTheme?.theme?.extra_small_font_size,
                          color: currentTheme?.theme?.font_color,
                        }}
                      >
                        {widgetString}
                      </code>
                    </pre>
                  )}
                </View>
              </AppExpander>
            )}

          {isChatBot && !isAgentOllama && values?.mode != "planner" && (
            <AppExpander
              style={{ minWidth: 250, zIndex: -1 }}
              title="Moderation and Feedback"
              icon={AppAssets.icons.scan}
            >
              <View
                style={{
                  paddingLeft: 10,
                }}
              >
                <AppForms.AppFormSwitch
                  wrapperStyle={[
                    {
                      backgroundColor: isEdit
                        ? currentTheme?.theme?.grey
                        : currentTheme?.theme?.lightGrey,
                      maxHeight: 30,
                      paddingHorizontal: 10,

                      paddingVertical: 18,
                      margin: 5,
                      marginTop: 20,
                    },
                  ]}
                  labelTextStyle={{
                    fontSize: currentTheme?.theme?.small_font_size,
                    color: currentTheme?.theme?.darkGrey,
                  }}
                  showTextInputLabel={true}
                  label={"Allow feedback"}
                  displayIsTicked={true}
                  name="allowFeedback"
                  value={values?.allowFeedback}
                />
                <AppForms.AppFormSwitch
                  // disabled={isEdit}
                  // disabled={true}
                  wrapperStyle={[
                    {
                      backgroundColor: isEdit
                        ? currentTheme?.theme?.grey
                        : currentTheme?.theme?.lightGrey,
                      maxHeight: 30,
                      paddingHorizontal: 10,

                      paddingVertical: 18,
                      margin: 5,
                      marginTop: 20,
                    },
                  ]}
                  labelTextStyle={{
                    fontSize: currentTheme?.theme?.small_font_size,
                    color: currentTheme?.theme?.darkGrey,
                  }}
                  showTextInputLabel={true}
                  label={"Content moderation"}
                  displayIsTicked={true}
                  name="hasModeration"
                  value={values?.hasModeration}
                />
                <AppForms.AppFormFieldJSONV2
                  showTextInputLabel
                  isMandatory
                  wrapperInputStyle={{
                    paddingTop: 0,
                  }}
                  wrapperContainer={{
                    height: 450,
                    paddingTop: 10,
                  }}
                  mode="code"
                  // schema={validations.parametersVal}
                  label={`Moderation rules`}
                  name="customModerations"
                  darkMode={mode === "dark"}
                />
                <AppForms.AppFormField
                  showTextInputLabel
                  wrapperInputStyle={{
                    paddingTop: 10,
                  }}
                  textContainer={{
                    minHeight: 120,
                    paddingVertical: 10,
                  }}
                  multiline={true}
                  label={`Message on moderation`}
                  placeholder={`Insert the message to be displayed when a user is moderated`}
                  keyboardtype="default"
                  textContextType="label"
                  autoCorrect={false}
                  name="moderationMessage"
                />
              </View>
            </AppExpander>
          )}
          <AppExpander
            style={{ minWidth: 250, zIndex: -1 }}
            title="Hosting and Models"
            icon={AppAssets.icons.hosting}
          >
            <View
              style={{
                paddingLeft: 0,
              }}
            >
              {!["planner", "computer"].includes(values?.mode) && (
                <>
                  <AppForms.AppFormDropDown
                    isElevated={false}
                    dropDownStyle={{
                      borderColor: currentTheme?.theme?.border_color,
                      maxWidth: !isLargeScreen() && 250,
                    }}
                    showTextInputLabel
                    label="LLM provider"
                    isMandatory
                    name="llmProvider"
                    items={baseLlmProviders}
                    propertyLabel="name"
                    propertyValue="id"
                  />

                  <AppForms.AppFormDropDown
                    isElevated={false}
                    dropDownStyle={{
                      borderColor: currentTheme?.theme?.border_color,
                      maxWidth: !isLargeScreen() && 250,
                    }}
                    showTextInputLabel
                    label="Base model"
                    isMandatory
                    name="llmBaseModel"
                    items={isAgentOllama ? oLlamaModels : baseLlmModels}
                    propertyLabel="name"
                    propertyValue="id"
                  />
                  {_baseModels?.find((u) => u?.id == values?.llmBaseModel)
                    ?.reasoner && (
                    <>
                      <AppForms.AppFormDropDown
                        isElevated={false}
                        inputLabelStyle={{
                          marginLeft: 10,
                        }}
                        // wrapperContainerStyle={{
                        //   marginLeft: 5,
                        //   marginBottom: 10,
                        // }}
                        name="reasoningMode"
                        dropDownStyle={{
                          borderColor: currentTheme?.theme?.border_color,
                          maxWidth: !isLargeScreen() && 250,
                        }}
                        showTextInputLabel
                        label={`Reasoning mode`}
                        isMandatory
                        items={[
                          {
                            name: "Auto",
                            id: "auto",
                          },
                          {
                            name: "Always",
                            id: "always",
                          },
                          {
                            name: "Never",
                            id: "never",
                          },
                        ]}
                        propertyLabel="name"
                        propertyValue="id"
                      />
                    </>
                  )}
                  {values?.llmBaseModel == "dynamic" && (
                    <AppForms.AppFormField
                      showTextInputLabel
                      wrapperInputStyle={{
                        paddingTop: 10,
                      }}
                      formFieldContainerStyle={{
                        zIndex: 10,
                      }}
                      textContainer={{
                        minHeight: 120,
                        paddingVertical: 10,
                      }}
                      multiline={true}
                      label={`Model routing instructions`}
                      placeholder={`agent_model_routing_placeholder`}
                      keyboardtype="default"
                      textContextType="label"
                      autoCorrect={false}
                      name="dynamicModelSelectionInstructions"
                      mentioning
                      mentions={matchModelsWithProviders(
                        "tf",
                        getActiveWorkspace()?.subscriptionType,
                        false,
                        customHostings
                      )
                        ?.filter(
                          (u) => u?.id !== "dynamic" && u?.dynamicRouting
                        )
                        ?.map((i) => {
                          return {
                            id: i.id,
                            label: i.name,
                          };
                        })}
                      onMentionSelect={(mention) => console.log(mention)}
                    />
                  )}
                </>
              )}

              {pullProgress != 0 &&
                pullStatus != "" &&
                customHostings?.find(
                  (u) => values?.llmProvider == u?.name && u?.type == "ollama"
                ) &&
                (loadedModel == values?.llmBaseModel ||
                  downloadingModel == values?.llmBaseModel) && (
                  <AppText
                    wrapperStyle={{
                      marginLeft: 20,
                    }}
                    color={currentTheme?.theme?.orange}
                    style={{
                      fontWeight: "bold",
                    }}
                    preventTranslation
                  >
                    {pullStatus.charAt(0).toUpperCase() + pullStatus.slice(1)} -{" "}
                    {Math.round(pullProgress * 100) / 100}%
                  </AppText>
                )}
              {isChatBot && !isAgentOllama && (
                <>
                  <View
                    style={{
                      height: 1,
                      backgroundColor: currentTheme?.theme?.mediumGrey,
                      marginVertical: 10,
                    }}
                  />
                  <AppForms.AppFormDropDown
                    isElevated={false}
                    dropDownStyle={{
                      borderColor: currentTheme?.theme?.border_color,
                      maxWidth: !isLargeScreen() && 250,
                    }}
                    showTextInputLabel
                    label={`${convertContextWithFunctionCallingLabel(
                      values?.mode
                    )} provider`}
                    isMandatory
                    name="functionCallingProvider"
                    items={
                      values?.mode == "planner"
                        ? [{ name: "ToothFairyAI", id: "tf" }]
                        : functionCallingProviders
                    }
                    propertyLabel="name"
                    propertyValue="id"
                    disabled={values?.mode == "computer"}
                  />
                  <AppForms.AppFormDropDown
                    isElevated={false}
                    dropDownStyle={{
                      borderColor: currentTheme?.theme?.border_color,
                      maxWidth: !isLargeScreen() && 250,
                    }}
                    showTextInputLabel
                    label={`${convertContextWithFunctionCallingLabel(
                      values?.mode
                    )} model`}
                    isMandatory
                    name="functionCallingModel"
                    items={functionCallingModels?.filter((u) => {
                      if (
                        values?.mode == "planner" ||
                        values?.mode == "computer"
                      )
                        return u?.plannerAvailable == true;
                      else return u?.preventFunctionCalling != true;
                    })}
                    disabled={values?.mode == "computer"}
                    propertyLabel="name"
                    propertyValue="id"
                  />
                </>
              )}

              {values?.mode == "planner" && (
                <>
                  <View
                    style={{
                      height: 1,
                      backgroundColor: currentTheme?.theme?.mediumGrey,
                      marginVertical: 10,
                    }}
                  />
                  <AppForms.AppFormDropDown
                    isElevated={false}
                    dropDownStyle={{
                      borderColor: currentTheme?.theme?.border_color,
                      maxWidth: !isLargeScreen() && 250,
                    }}
                    showTextInputLabel
                    label={`Reviewer provider`}
                    isMandatory
                    name="adverserialProvider"
                    items={[{ name: "ToothFairyAI", id: "tf" }]}
                    propertyLabel="name"
                    propertyValue="id"
                  />
                  <AppForms.AppFormDropDown
                    isElevated={false}
                    dropDownStyle={{
                      borderColor: currentTheme?.theme?.border_color,
                      maxWidth: !isLargeScreen() && 250,
                    }}
                    showTextInputLabel
                    label={`Reviewer model`}
                    isMandatory
                    name="adverserialModel"
                    items={adverserialModels?.filter((u) => {
                      if (
                        values?.mode == "planner" ||
                        values?.mode == "computer"
                      )
                        return u?.plannerAvailable == true;
                      else return u?.preventFunctionCalling != true;
                    })}
                    propertyLabel="name"
                    propertyValue="id"
                  />
                </>
              )}

              {isChatBot &&
                !isAgentOllama &&
                (values?.mode == "chatter" || values?.mode == "retriever") && (
                  <>
                    <View
                      style={{
                        height: 1,
                        backgroundColor: currentTheme?.theme?.mediumGrey,
                        marginVertical: 10,
                      }}
                    />
                    <AppForms.AppFormDropDown
                      isElevated={false}
                      dropDownStyle={{
                        borderColor: currentTheme?.theme?.border_color,
                        maxWidth: !isLargeScreen() && 250,
                      }}
                      showTextInputLabel
                      label={`Vision provider`}
                      isMandatory
                      items={functionCallingProviders}
                      propertyLabel="name"
                      propertyValue="id"
                      disabled
                    />
                    <AppForms.AppFormDropDown
                      isElevated={false}
                      dropDownStyle={{
                        borderColor: currentTheme?.theme?.border_color,
                        maxWidth: !isLargeScreen() && 250,
                      }}
                      showTextInputLabel
                      label={`Vision model`}
                      isMandatory
                      name="visionModel"
                      items={visionModels}
                      propertyLabel="name"
                      propertyValue="id"
                    />
                  </>
                )}
            </View>
          </AppExpander>
          <View
            style={{
              zIndex: -1,
            }}
          >
            {isChatBot && !isAgentOllama && (
              <AppExpander
                style={{ minWidth: 250, zIndex: -1 }}
                title="Agent channels"
                icon={AppAssets.icons.channels}
                iconSize={20}
              >
                <View
                  style={{
                    paddingLeft: 0,
                  }}
                >
                  {getActiveWorkspace()?.subscriptionType != "base" && (
                    <>
                      <AppForms.AppFormSwitch
                        // disabled={isEdit}
                        // disabled={true}
                        wrapperStyle={[
                          {
                            backgroundColor: isEdit
                              ? currentTheme?.theme?.grey
                              : currentTheme?.theme?.lightGrey,
                            maxHeight: 30,
                            paddingHorizontal: 10,

                            paddingVertical: 18,
                            marginBottom: 5,
                            marginTop: 20,
                            marginHorizontal: 10,
                          },
                        ]}
                        labelTextStyle={{
                          fontSize: currentTheme?.theme?.small_font_size,
                          color: currentTheme?.theme?.darkGrey,
                        }}
                        showTextInputLabel={true}
                        label={"Enable agent TF email"}
                        displayIsTicked={true}
                        name="allowEmailToAgent"
                        value={values?.allowEmailToAgent}
                      />
                      <AppForms.AppFormSwitch
                        // disabled={isEdit}
                        // disabled={true}
                        wrapperStyle={[
                          {
                            backgroundColor: isEdit
                              ? currentTheme?.theme?.grey
                              : currentTheme?.theme?.lightGrey,
                            maxHeight: 30,
                            paddingHorizontal: 10,

                            paddingVertical: 18,
                            marginBottom: 15,
                            marginTop: 20,
                            marginHorizontal: 10,
                          },
                        ]}
                        labelTextStyle={{
                          fontSize: currentTheme?.theme?.small_font_size,
                          color: currentTheme?.theme?.darkGrey,
                        }}
                        showTextInputLabel={true}
                        label={"New chat on received msg."}
                        displayIsTicked={true}
                        name="forceNewThreadOnProgrammaticRequest"
                        value={values?.forceNewThreadOnProgrammaticRequest}
                      />
                    </>
                  )}

                  {values?.allowEmailToAgent && (
                    <View
                      style={{
                        marginTop: 10,
                      }}
                    >
                      <AppText
                        wrapperStyle={{
                          paddingHorizontal: 20,
                        }}
                        iconSize={16}
                        leftIcon={AppAssets?.icons?.info}
                        color={currentTheme?.theme?.orange}
                        style={{
                          marginLeft: 20,
                        }}
                      >
                        The agent will receive and send emails on the following
                        email address
                      </AppText>
                      <AppText
                        iconSize={16}
                        wrapperStyle={{
                          alignSelf: "flex-start",
                          marginBottom: 10,
                          width: "100%",
                          marginTop: 10,
                          paddingRight: 10,
                        }}
                        leftIcon={AppAssets?.icons?.email}
                        leftIconStyle={{
                          marginLeft: 20,
                        }}
                        style={{
                          color: currentTheme?.theme?.primary,
                          left: 55,
                          fontWeight: "bold",
                          position: "absolute",
                        }}
                        rightIcon={AppAssets?.icons?.quickCopy}
                        isClickable
                        onRightIconPress={() => {
                          AppToasty.show("Copied to clipboard", {
                            type: "success",
                          });
                          navigator.clipboard.writeText(
                            `${values?.label} <${values?.id}@mail.${
                              envConfig?.REACT_APP_ENV == "dev"
                                ? "toothfairylab.link"
                                : "toothfairyai.com"
                            }>`
                          );
                        }}
                        textStyle={{
                          marginLeft: 0,
                        }}
                        width={420}
                      >
                        {`${values?.id}@mail.${
                          envConfig?.REACT_APP_ENV == "dev"
                            ? "toothfairylab.link"
                            : "toothfairyai.com"
                        }`}
                      </AppText>
                      <AppForms.AppFormField
                        showTextInputLabel
                        wrapperInputStyle={{
                          paddingTop: 10,
                        }}
                        multiline={true}
                        textContainer={{
                          minHeight: 120,
                          paddingVertical: 10,
                        }}
                        label={`Restrict allowed email addresses`}
                        placeholder={`Insert a list of allowed email addresses separated by semicolons. If left empty, all email addresses will be able to interact with this agent.`}
                        keyboardtype="default"
                        textContextType="label"
                        autoCorrect={false}
                        name="allowedEmails"
                      />
                    </View>
                  )}
                  <AppForms.AppFormMultiSelect
                    name="communicationServices"
                    placeholder="Assign custom channels"
                    hidePlaceholder={true}
                    items={agentsChannels}
                    uniqueKey="id"
                    showDropDowns={true}
                    readOnlyHeadings={true}
                    labelOption="name"
                    groupByProperty="channel"
                    style={{ maxWidth: 800 }}
                    wrapperContainerStyle={{
                      flex: !isLargeScreen() ? 1 : 0.5,
                      zIndex: 20,
                      paddingTop: 10,
                      marginBottom: 30,
                      marginHorizontal: 10,
                    }}
                    styles={colourStyles}
                    options={agentsChannels?.map((u) => {
                      return {
                        ...u,
                        label: u?.name + " - " + u?.provider,
                        value: u?.id,
                        backgroundColor: Utility?.mapFunctionTypeToColour(
                          u,
                          currentTheme
                        ),
                      };
                    })}
                  />

                  {values?.communicationServices?.find(
                    (u) => u?.channel == "sms"
                  ) && (
                    <AppForms.AppFormField
                      showTextInputLabel
                      wrapperInputStyle={{
                        paddingTop: 10,
                      }}
                      errorOffset={0}
                      label={`Phone number`}
                      placeholder={`Insert the phone number the agent should send messages from`}
                      keyboardtype="default"
                      textContextType="label"
                      autoCorrect={false}
                      name="phoneNumberAsSender"
                    />
                  )}
                  {values?.communicationServices?.find(
                    (u) => u?.channel == "whatsapp"
                  ) && (
                    <AppForms.AppFormField
                      showTextInputLabel
                      wrapperInputStyle={{
                        paddingTop: 10,
                      }}
                      errorOffset={0}
                      label={`Whatsapp number`}
                      placeholder={`Insert the whatsapp number the agent should send messages from`}
                      keyboardtype="default"
                      textContextType="label"
                      autoCorrect={false}
                      name="whatsappNumberAsSender"
                    />
                  )}
                  {values?.communicationServices?.find(
                    (u) => u?.channel == "email"
                  ) && (
                    <AppForms.AppFormField
                      showTextInputLabel
                      wrapperInputStyle={{
                        paddingTop: 10,
                      }}
                      errorOffset={0}
                      label={`Email address`}
                      placeholder={`Insert the email address the agent should send messages from`}
                      keyboardtype="default"
                      textContextType="label"
                      autoCorrect={false}
                      name="emailAsSender"
                    />
                  )}
                  <View
                    style={{
                      marginLeft: 20,
                      marginTop: 10,
                    }}
                  >
                    <AppForms.AppFormSecureTextInput
                      minimumValue={0}
                      maximumValue={120}
                      step={1}
                      label="Delivery callback delay in seconds"
                      inputType="SLIDER"
                      name="channelCallbackDelay"
                    />
                  </View>
                </View>
              </AppExpander>
            )}
          </View>
          <View
            style={{
              zIndex: 0,
            }}
          >
            <AppExpander
              style={{ minWidth: 250, zIndex: -1 }}
              title="Advanced settings"
              icon={AppAssets.icons.experiment}
            >
              <View
                style={{
                  paddingLeft: 10,
                }}
              >
                <View
                  style={{
                    marginLeft: 10,
                    marginTop: 10,
                  }}
                >
                  <AppForms.AppFormSecureTextInput
                    minimumValue={0.01}
                    maximumValue={1}
                    step={0.01}
                    label="Temperature"
                    inputType="SLIDER"
                    name="temperature"
                  />

                  <AppForms.AppFormSlider
                    step={1}
                    maximumValue={getMaxTokens(
                      isContentCreator,
                      isChatBot,
                      getActiveWorkspace,
                      values
                    )}
                    minimumValue={50}
                    label="Max output tokens"
                    name="maxTokens"
                    showEditButtons={true}
                  />
                  {/* {_baseModels?.find((u) => u?.id == values?.llmBaseModel)
                    ?.reasoner && (
                    <>
                      <AppForms.AppFormSlider
                        step={1}
                        maximumValue={values?.maxTokens - 50}
                        minimumValue={0}
                        label="Max reasoning tokens"
                        name="reasoningBudget"
                        showEditButtons={true}
                      />

                      <AppText
                        leftIcon={AppAssets?.icons?.info}
                        wrapperStyle={{
                          paddingHorizontal: 10,
                        }}
                        color={currentTheme?.theme?.orange}
                        style={{
                          marginLeft: 10,
                        }}
                        iconSize={14}
                      >
                        Reasoning budget refers to the maximum number of
                        reasoning tokens a model can use to produce an accurate
                        answer. This setting only applies to reasoning TF
                        models.
                      </AppText>
                    </>
                  )} */}
                </View>
                <View>
                  {isChatBot && (
                    <>
                      {isKnowledgeEnabled && (
                        <AppForms.AppFormSwitch
                          wrapperStyle={[
                            {
                              backgroundColor: isEdit
                                ? currentTheme?.theme?.grey
                                : currentTheme?.theme?.lightGrey,
                              maxHeight: 30,
                              paddingHorizontal: 10,

                              paddingVertical: 18,
                              margin: 5,
                              marginTop: 20,
                            },
                          ]}
                          labelTextStyle={{
                            fontSize: currentTheme?.theme?.small_font_size,
                            color: currentTheme?.theme?.darkGrey,
                          }}
                          showTextInputLabel={true}
                          label={"Plain text output"}
                          displayIsTicked={true}
                          name="plainTextOutput"
                          value={values?.plainTextOutput}
                        />
                      )}
                      {(isChatBot || isContentCreator) &&
                        isKnowledgeEnabled &&
                        !isAgentOllama && (
                          <View>
                            <AppForms.AppFormSwitch
                              wrapperStyle={[
                                {
                                  backgroundColor: isEdit
                                    ? currentTheme?.theme?.grey
                                    : currentTheme?.theme?.lightGrey,
                                  maxHeight: 30,
                                  paddingHorizontal: 10,

                                  paddingVertical: 18,
                                  margin: 5,
                                  marginTop: 20,
                                },
                              ]}
                              labelTextStyle={{
                                fontSize: currentTheme?.theme?.small_font_size,
                                color: currentTheme?.theme?.darkGrey,
                              }}
                              showTextInputLabel={true}
                              label={"Show docs refs"}
                              displayIsTicked={true}
                              name="showReferencesToInternalDocs"
                              value={values?.showReferencesToInternalDocs}
                            />
                          </View>
                        )}
                      {values?.mode != "planner" && !isAgentOllama && (
                        <>
                          <AppForms.AppFormSwitch
                            wrapperStyle={[
                              {
                                backgroundColor: isEdit
                                  ? currentTheme?.theme?.grey
                                  : currentTheme?.theme?.lightGrey,
                                maxHeight: 30,
                                paddingHorizontal: 10,

                                paddingVertical: 18,
                                margin: 5,
                                marginTop: 20,
                              },
                            ]}
                            labelTextStyle={{
                              fontSize: currentTheme?.theme?.small_font_size,
                              color: currentTheme?.theme?.darkGrey,
                            }}
                            showTextInputLabel={true}
                            label={"Prompt enhancement"}
                            displayIsTicked={true}
                            name="promptBuffering"
                            value={values?.promptBuffering}
                          />
                        </>
                      )}

                      {values?.mode == "chatter" && !isAgentOllama && (
                        <AppForms.AppFormSwitch
                          wrapperStyle={[
                            {
                              backgroundColor: isEdit
                                ? currentTheme?.theme?.grey
                                : currentTheme?.theme?.lightGrey,
                              maxHeight: 30,
                              paddingHorizontal: 10,

                              paddingVertical: 18,
                              margin: 5,
                              marginTop: 20,
                            },
                          ]}
                          labelTextStyle={{
                            fontSize: currentTheme?.theme?.small_font_size,
                            color: currentTheme?.theme?.darkGrey,
                          }}
                          showTextInputLabel={true}
                          label={"Entities extraction mode"}
                          displayIsTicked={true}
                          name="hasEntityExtraction"
                          value={values?.hasEntityExtraction}
                        />
                      )}
                      {(values?.hasCode || values?.mode == "planner") && (
                        <View>
                          <AppForms.AppFormSwitch
                            wrapperStyle={[
                              {
                                backgroundColor: isEdit
                                  ? currentTheme?.theme?.grey
                                  : currentTheme?.theme?.lightGrey,
                                maxHeight: 30,
                                paddingHorizontal: 10,

                                paddingVertical: 18,
                                margin: 5,
                                marginTop: 20,
                              },
                            ]}
                            labelTextStyle={{
                              fontSize: currentTheme?.theme?.small_font_size,
                              color: currentTheme?.theme?.darkGrey,
                            }}
                            showTextInputLabel={true}
                            label={"Show code blocks"}
                            displayIsTicked={true}
                            name="showCodeInExecution"
                            value={values?.showCodeInExecution}
                          />
                        </View>
                      )}
                      {
                        <View>
                          <AppForms.AppFormSwitch
                            wrapperStyle={[
                              {
                                backgroundColor: isEdit
                                  ? currentTheme?.theme?.grey
                                  : currentTheme?.theme?.lightGrey,
                                maxHeight: 30,
                                paddingHorizontal: 10,

                                paddingVertical: 18,
                                margin: 5,
                                marginTop: 20,
                              },
                            ]}
                            labelTextStyle={{
                              fontSize: currentTheme?.theme?.small_font_size,
                              color: currentTheme?.theme?.darkGrey,
                            }}
                            showTextInputLabel={true}
                            label={"Show reasoning"}
                            displayIsTicked={true}
                            name="hideReasoning"
                            value={values?.hideReasoning}
                          />
                        </View>
                      }

                      <AppForms.AppFormSwitch
                        wrapperStyle={[
                          {
                            backgroundColor: isEdit
                              ? currentTheme?.theme?.grey
                              : currentTheme?.theme?.lightGrey,
                            maxHeight: 30,
                            paddingHorizontal: 10,

                            paddingVertical: 18,
                            margin: 5,
                            marginTop: 20,
                          },
                        ]}
                        labelTextStyle={{
                          fontSize: currentTheme?.theme?.small_font_size,
                          color: currentTheme?.theme?.darkGrey,
                        }}
                        showTextInputLabel={true}
                        label={"Show response time"}
                        displayIsTicked={true}
                        name="showTimeForResponse"
                        value={values?.showTimeForResponse}
                      />

                      {!isAgentOllama && (
                        <AppForms.AppFormSwitch
                          wrapperStyle={[
                            {
                              backgroundColor: isEdit
                                ? currentTheme?.theme?.grey
                                : currentTheme?.theme?.lightGrey,
                              maxHeight: 30,
                              paddingHorizontal: 10,

                              paddingVertical: 18,
                              margin: 5,
                              marginTop: 20,
                            },
                          ]}
                          labelTextStyle={{
                            fontSize: currentTheme?.theme?.small_font_size,
                            color: currentTheme?.theme?.darkGrey,
                          }}
                          showTextInputLabel={true}
                          label={"Show routed model"}
                          displayIsTicked={true}
                          name="showRoutedModel"
                          value={values?.showRoutedModel}
                        />
                      )}
                    </>
                  )}
                </View>
                <>
                  <AppForms.AppFormSwitch
                    wrapperStyle={[
                      {
                        backgroundColor: isEdit
                          ? currentTheme?.theme?.grey
                          : currentTheme?.theme?.lightGrey,
                        maxHeight: 30,
                        paddingHorizontal: 10,

                        paddingVertical: 18,
                        margin: 5,
                        marginTop: 20,
                      },
                    ]}
                    labelTextStyle={{
                      fontSize: currentTheme?.theme?.small_font_size,
                      color: currentTheme?.theme?.darkGrey,
                    }}
                    showTextInputLabel={true}
                    label={"Restrict access"}
                    displayIsTicked={true}
                    name="restrictedAccess"
                    value={values?.restrictedAccess}
                  />
                  {values?.restrictedAccess && (
                    <AppForms.AppFormMultiSelect
                      name="restrictedAccessUsers"
                      topErrorOffset={-21}
                      touchedByDefault
                      placeholder="Allow access to specific users"
                      hidePlaceholder={true}
                      items={getWorkspaceUsers()}
                      uniqueKey="id"
                      showDropDowns={true}
                      readOnlyHeadings={true}
                      style={{ maxWidth: 800 }}
                      wrapperContainerStyle={{
                        flex: !isLargeScreen() ? 1 : 0.5,
                        zIndex: 20,
                        paddingTop: 15,
                        marginBottom: 40,
                        marginHorizontal: 5,
                      }}
                      styles={colourStyles}
                      options={getWorkspaceUsers().map((u) => {
                        return {
                          ...u,
                          value: u?.id,
                          label: u?.username || u?.user_email,
                          category: "user",
                          backgroundColor: AppUtilities.stringToHslColor(
                            u?.username || u?.user_email,
                            71
                          ),
                        };
                      })}
                    />
                  )}
                </>
              </View>
            </AppExpander>
          </View>
          {isChatBot &&
            !isAgentOllama &&
            values?.mode != "planner" &&
            values?.mode != "computer" && (
              <View style={{ zIndex: -1 }}>
                <AppExpander
                  style={{ minWidth: 250, zIndex: -1 }}
                  title="Agent benchmarks scoring"
                  icon={AppAssets.icons.benchmark}
                >
                  {benchmarks?.length > 0 ? (
                    <AppTable
                      style={{
                        zIndex: -1,
                        maxHeight: 300,
                        paddingRight: 20,
                        overflowY: "auto",
                        overflowX: "hidden",
                        paddingLeft: 10,
                      }}
                      headers={columns}
                      items={benchmarks?.slice(0, 20)?.map((u) => {
                        return {
                          name: u?.benchmark?.name || "",
                          score:
                            parseFloat(
                              u?.batch?.batchMeta?.scoring_summary
                                ?.average_overall_score || 0
                            )
                              ?.toFixed(2)
                              ?.toString() || "NA",
                          datetime:
                            dayjs(u?.batch?._lastChangedAt)?.format(
                              "DD-MM-YYYY HH:mm"
                            ) || " ",
                        };
                      })}
                    />
                  ) : (
                    <View
                      style={{
                        paddingLeft: 0,
                      }}
                    >
                      <AppPlaceholderView
                        wrapperStyle={{
                          width: "80%",
                          height: "100%",
                          marginVertical: "auto",
                          marginHorizontal: "auto",
                          alignItems: "center",
                        }}
                        size={30}
                        icon={AppAssets.icons.orbit}
                        mainCaption="Nothing to show here yet..."
                        subCaption="Run your first benchmark using this agent to see the scoring here"
                      />
                    </View>
                  )}
                </AppExpander>
              </View>
            )}
        </View>
        <View style={{ alignItems: "center", zIndex: -5 }}>
          <AppForms.AppSubmitButton
            title={_title()}
            awesomeIconColor={currentTheme?.theme?.white}
            backgroundColor={currentTheme?.theme?.primary}
            btnContentStyle={{
              paddingLeft: 0,
              paddingRight: 0,
            }}
            style={[
              {
                height: Constants.appButtonHeight,
                width: "auto",
                shadowColor: currentTheme?.theme?.transparent,
                marginHorizontal: 10,
              },
            ]}
            // btnLabelStyle={{ fontSize: 16 }}
            wrapperStyle={[
              {
                zIndex: -1,
                width: "fit-content",
                minWidth: 150,
                marginTop: 20,
                height: Constants.appButtonHeight,
              },
            ]}
          />
          {isEdit && (
            <ToothFairyButton
              title={"Delete"}
              onPress={handleDeletion}
              isDeletion
              wrapperStyle={{
                marginTop: 30,
                minWidth: 150,
                height: Constants.appButtonHeight,
              }}
            />
          )}
        </View>
      </View>
    </AppToast.ToastProvider>
  );
};

export default QaSettingsAIView;
